import React, { useContext, useEffect, useState, useRef } from "react";
import AdminContext from "../../../admin/StateContext/Application";
import ReactApexChart from "react-apexcharts";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "react-datepicker/dist/react-datepicker.css";
import "./page.css";
import {
  Approved32,
  AvailableBalance,
  Click32,
  Disable32,
  Earnings,
  Earningss,
  Earningsss,
  Error32,
  ExcessShortfall64,
  fifth,
  first,
  forth,
  Graph64,
  MoreMenu64,
  NewTasks64,
  Sales,
  Second,
  Spendthismonth64,
  third,
  TotalProjectCost,
  TotalProjects64,
  Unclick32,
  YourBalance,
} from "../../../../public/LoginImages/importimages";
import "../../../Users/pages/innercss.css";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import { apiurl } from "../../../../path";
import { jwtDecode } from "jwt-decode";
import { formatDateTime, formatDate } from '../../../../utils/DateFormat';

const ProjectDashboard = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  console.log("userData: ", userData);
  const { language, toggleLanguage, t } = useLanguage();
  const content = useContext(AdminContext);
  const {
    GetTaxAmounts,
    GetVendorBills,
    getTaxAmountsByDate,
    GetDateWiseData,
    GetProjectTotal,
    GetTotalAmountAvailbaleInBank,
    GetLiabilityTotal,
    GetProjectInfo,
    GetBudgetHeadInfo,
    Getyears,
  } = content;
  const [getData, SetData] = useState({});
  const [vendorbills, setVendorBills] = useState([]);
  const [taxesData, SetTaxesData] = useState({});
  const [loading, setloading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateData, setDateData] = useState([]);
  const [projectdata, setProjectData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const [demandList, setDemandList] = useState();
  const [showspecific, setSpecific] = useState(0);
  const [availabeBalancinBank, setAvailabeBalancinBank] = useState([]);
  const [CountBalance, setCountBalance] = useState([]);
  const [newData, setNewData] = useState([]);
  const billsPerPage = 10; // this will show entries

  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexofLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexofLastBill - billsPerPage;
  const currentBills = filteredBills.slice(indexOfFirstBill, indexofLastBill);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [selectedDistrict, setselectedDistrict] = useState("");
  const [selectedTaluka, setselectedTaluka] = useState("");
  const [selectedType, setselectedType] = useState("");
  const [filtereddemand, setFiltereddemands] = useState([]);
  const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const totalPages1 = Math.ceil(filtereddemand.length / billsPerPage);
  const totalPages2 = Math.ceil(availabeBalancinBank.length / billsPerPage);
  const currentdemands = filtereddemand.slice(
    indexOfFirstBill,
    indexofLastBill,
  );
  const currentbalance = availabeBalancinBank.slice(
    indexOfFirstBill,
    indexofLastBill,
  );
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedLiabilityDivision, setSelectedLiabilityDivision] = useState("");
  const [selectedLiabilityStatus, setSelectedLiabilityStatus] = useState("");
  const [filteredLiabilityDemand, setFilteredLiabilityDemand] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [showVendorModal, setShowVendorModal] = useState(false);
  const [vendorModalLoading, setVendorModalLoading] = useState(false);
  const [vendorModalData, setVendorModalData] = useState([]);
  const [vendorModalDemandID, setVendorModalDemandID] = useState("");

  const getDemandStatus = (val) => {
    if (val.Approvance8 == "true" && val.Approvance9 == "true") return "Approved";
    return "Pending";
  };
  // const getProjectStatus = (val) => {
  //   if (
  //     val.Approvance1 == "true" &&
  //     val.Approvance2 == "true" &&
  //     val.Approvance3 == "true"
  //   ) {
  //     return "Approved";
  //   }
  //   return "Pending";
  // };
// const getProjectStatus = (val) => {
//   const a1 = String(val.Approvance1).toLowerCase();
//   const a2 = String(val.Approvance2).toLowerCase();
//   const a3 = String(val.Approvance3).toLowerCase();
//   const status = String(val.Status).trim().toLowerCase();

//   // Status Rejected → Rejected
//   if (status === "rejected") {
//     return "Rejected";
//   }

//   // All three approvals true → Approved
//   if (a1 === "true" && a2 === "true" && a3 === "true") {
//     return "Approved";
//   }

//   // Any one false → Pending
//   return "Pending";
// };


const getProjectStatus = (val) => {
  const status = String(val.ReleasedByBDS ?? "").trim().toLowerCase();
  const stateApproved = String(val.StateApprovance ?? "").toLowerCase() === "true";

  if (status === "rejected") return "Rejected";

  // Final state: money actually paid
 if (status === "successful/paid") return "Successful/Paid";

  // Bill sent to the bank, not yet confirmed paid
  if (status === "sent to bank") return "Sent to Bank";

  // BDS released it (Approvance9 = true) but not yet sent to bank
  if (stateApproved) return "Released By BDS";

  // null, empty, false, or anything else
  return "Pending";
};



  const [previousSpecific, setPreviousSpecific] = useState(0);

  const [bankDistrict, setBankDistrict] = useState("");
  const [bankTaluka, setBankTaluka] = useState("");
  const [bankSearchTerm, setBankSearchTerm] = useState("");
  const [filteredBankBalance, setFilteredBankBalance] = useState([]);

  // Bill Slip states
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [selectedBillData, setSelectedBillData] = useState({});
  const [
    fetchSpecificDemandDeductionDetail,
    setFetchSpecificDemandDeductionDetail,
  ] = useState([]);
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);
  const billSlipRef = useRef(null);

  // Liability export state
  const [exportingLiabilityPDF, setExportingLiabilityPDF] = useState(false);

  // Styles needed for the bill slip (copy from ViewDemandGeneration)
  const footerTitleStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "8px",
  };
  const footerTitleTdStyle = {
    border: "1px solid #555",
    padding: "6px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
  };
  const remarksTableStyle = { width: "100%", borderCollapse: "collapse" };
  const remarksTableTdStyle = {
    border: "1px solid #555",
    padding: "8px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "right",
  };
  const instructionTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };
  const instructionTableTdStyle = {
    border: "1px solid #555",
    padding: "10px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "justify",
  };

  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,
  });

  useEffect(() => {
    GetAmountOfTaxes();
    getVendorbill();
    getTaxesAmountbyDate();
    GetAllProjectTotal();
    GetTotalAmountAvailableInBank();
    GetLiabilityTotalAmount();
  }, []);

  const GetAmountOfTaxes = async () => {
    let data = await GetTaxAmounts();
    console.log(data);
    SetData((prevState) => {
      return data;
    });
    setloading(false);
  };

  const GetAllProjectTotal = async () => {
    let data = await GetProjectTotal();
    console.log("projectdata", data);
    setProjectData(data);
    setTableData(data);
    setNewData(data);
    setFilteredBills(data || []);
    // setloading(false);
  };

  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce(
      (acc, item) => acc + Number(item.EsitmateAmount),
      0,
    );

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount,
    }));
  };

  useEffect(() => {
    TotalAmount();
  }, [tableData]);

  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   const filtered = newData?.filter(item =>
  //     Object.values(item || {}).some(val =>
  //       (val || '').toString().toLowerCase().includes(lowerSearchTerm)
  //     )
  //   );
  //   setFilteredBills(filtered || []);
  //   setCurrentPage(1);
  // }, [newData, searchTerm]);

  // useEffect(() => {
  //   if (selectedDistrict) {
  //     const filtered = newData?.filter((item) => item.District === selectedDistrict);
  //     setFilteredBills(filtered || []);
  //     setCurrentPage(1);
  //   }
  // }, [selectedDistrict]);

  // useEffect(() => {
  //   if (selectedTaluka) {
  //     const filtered = newData?.filter((item) => item.District === selectedDistrict && item.Taluka === selectedTaluka);
  //     setFilteredBills(filtered || []);
  //     setCurrentPage(1);
  //   }
  // }, [selectedTaluka]);

  useEffect(() => {
    setselectedTaluka("");
  }, [selectedDistricts]);

  // useEffect(() => {
  //   let filtered = newData;

  //   if (selectedDistricts.length > 0) {
  //     filtered = filtered.filter((item) =>
  //       selectedDistricts.includes(item.talulka),
  //     );
  //   }

  //   if (selectedTaluka) {
  //     filtered = filtered.filter((item) => item.ulb == selectedTaluka);
  //   }

  // if (selectedType) {
  //     filtered = filtered.filter(item => item.WorkOrderType == selectedType);
  //   }
  //   if (searchTerm.trim() !== "") {
  //     const lower = searchTerm.toLowerCase();
  //     filtered = filtered.filter((bill) =>
  //       Object.values(bill).some((val) =>
  //         (val || "").toString().toLowerCase().includes(lower),
  //       ),
  //     );
  //   }

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [searchTerm, newData, selectedDistrict, selectedTaluka,selectedType]);

  const getVendorbill = async () => {
    let data1 = await GetVendorBills();
    setVendorBills(data1);
    // setloading(false);
  };
  let vendorBillList = [];
  if (vendorbills.length > 0) {
    vendorBillList = vendorbills;
  }

  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank();
    console.log("Balank Detail 0---------------------", data);
    setBankBalance(data[0]);
    // setCountBalance(data.result1[0])
  };
  // let TotalPaidCount = BankBalance.AvailableBalanceinBank - CountBalance.SendAmountToVender

  // let TotalPaidCount = BankBalance.AvailableBalanceinBank;
  let TotalPaidCount = filteredBankBalance.reduce(
    (total, item) =>
      total + Number(item.LimitAllottedAmount || 0),
    0
  );
  console.log(TotalPaidCount);
  const GetLiabilityTotalAmount = async () => {
    let data = await GetLiabilityTotal();
    console.log(data);
    setLiabilityData(data[0]);
  };
  const getTaxesAmountbyDate = async () => {
    let data = await getTaxAmountsByDate();
    console.log(data);
  };
  const FetchDemandList = async () => {
    try {
      let res = await GetProjectInfo("", "");
      let res1 = await GetProjectInfo("", "avaiableInBank");
      console.log("Data if get ting ::", res1);
      setDemandList(res);
      console.log("Dmeand list data i ge t __________", res);
      setAvailabeBalancinBank(res1);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchDemandList();
  }, []);

  useEffect(() => {
    let filtered = availabeBalancinBank || [];

    // District filter
    if (bankDistrict) {
      filtered = filtered.filter(
        item => item.District === bankDistrict
      );
    }

    // Taluka filter
    if (bankTaluka) {
      filtered = filtered.filter(
        item => item.Taluka === bankTaluka
      );
    }

    // Search anything
    if (bankSearchTerm.trim() !== "") {
      const search = bankSearchTerm.toLowerCase().trim();

      filtered = filtered.filter(item =>
        Object.values(item || {}).some(value =>
          String(value ?? "")
            .toLowerCase()
            .includes(search)
        )
      );
    }

    setFilteredBankBalance(filtered);
    setCurrentPage(1);

  }, [
    availabeBalancinBank,
    bankDistrict,
    bankTaluka,
    bankSearchTerm
  ]);

  //For the Duplicacy of bill data
  useEffect(() => {
    if (demandList) {
      const filteredUnique = [
        ...new Map(
          demandList
            .filter((val) => val.DemandGenerationID)
            .map((item) => [item.DemandGenerationID, item]),
        ).values(),
      ];

      const totalBillAmount = filteredUnique.reduce((sum, item) => {
        return sum + Number(item.BillAmount || 0);
      }, 0);

      console.log("Total Bill Amount:", totalBillAmount);
      setLiabilityData(totalBillAmount);
      setFiltereddemands(filteredUnique);
    }
  }, [demandList]);


  useEffect(() => {
    const uniqueDemands = [
      ...new Map(
        (filtereddemand || [])
          .filter((val) => val.DemandGenerationID)
          .map((item) => [item.DemandGenerationID, item])
      ).values(),
    ];

    let filtered = uniqueDemands;

    // if (selectedLiabilityDivision) {
    //   filtered = filtered.filter(
    //     (val) => val.Division === selectedLiabilityDivision
    //   );
    // }
    if (selectedDistricts.length > 0) {
      filtered = filtered.filter((val) =>
        selectedDistricts.some((d) => {
          if (!val.District) return false;
          return (
            val.District === d ||               // exact match, e.g. "पुणे" === "पुणे"
            val.District.startsWith(d + "-")     // prefix match, e.g. "पुणे-उत्तर".startsWith("पुणे-")
          );
        })
      );
    }

    // if (selectedLiabilityStatus) {
    //   filtered = filtered.filter(
    //     (val) => getDemandStatus(val) === selectedLiabilityStatus
    //   );
    // }
    if (selectedLiabilityStatus) {
      filtered = filtered.filter(
        (val) => getBillStatus(val) === selectedLiabilityStatus
      );
    }


    setFilteredLiabilityDemand(filtered);
    setCurrentPage(1);
  }, [filtereddemand, selectedDistricts, selectedLiabilityStatus]);

  // Derived pagination values for this table
  const totalPagesLiability = Math.ceil(
    filteredLiabilityDemand.length / billsPerPage
  );
  const currentFilteredDemands = filteredLiabilityDemand.slice(
    indexOfFirstBill,
    indexofLastBill
  );

  // Unique divisions for the dropdown
  const allDivisions = [
    ...new Set(
      (filtereddemand || [])
        .map((v) => v.Division)
        .filter(Boolean)
    ),
  ];

  // useEffect(() => {
  //   if (selectedDistrict) {
  //     let res = AllDistrict.filter((item) => item.District_Marathi === selectedDistrict);
  //     setTalukasofDistrict(res);
  //   }
  // }, [selectedDistrict]);

  const FetchData = async () => {
    try {
      let res1 = await GetBudgetHeadInfo("null", "AllDistrict");
      setAllDistrict(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchData();
  }, []);

  useEffect(() => {
    if (selectedDistricts?.length > 0) {
      const res = AllDistrict.filter((item) => {
        const itemDistrict = item?.District_Marathi || "";

        return selectedDistricts.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });

      setTalukasofDistrict(res);
    } else {
      setTalukasofDistrict([]);
    }
  }, [selectedDistricts, AllDistrict]);


  useEffect(() => {
    let filtered = newData;

    if (selectedDistricts.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item?.talulka || "";

        return selectedDistricts.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
    }

    if (selectedTaluka) {
      filtered = filtered.filter((item) => item.ulb === selectedTaluka);
    }

    if (selectedType) {
      filtered = filtered.filter((item) => item.WorkOrderType == selectedType);
    }

    if (selectedHeadCode) {
      filtered = filtered.filter((item) =>
        item.HeadCode?.startsWith(selectedHeadCode),
      );
    }

    //     if (selectedStatus) {
    //   filtered = filtered.filter(item => item.Status === selectedStatus);
    // }

    if (selectedStatus) {
      filtered = filtered.filter(
        (item) => getProjectStatus(item) === selectedStatus
      );
    }

    if (searchTerm.trim() !== "") {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          (val || "").toString().toLowerCase().includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    searchTerm,
    newData,
    selectedDistricts,
    selectedTaluka,
    selectedType,
    selectedHeadCode,
    selectedStatus
  ]);

  const handleCheckboxChange = (district) => {
    setSelectedDistricts((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };
  const allDistricts = [
    ...new Set(
      AllDistrict?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      ).filter(Boolean)
    ),
  ];
  const isAllSelected = selectedDistricts.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistricts(isAllSelected ? [] : allDistricts);
  };

  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressImages, setProgressImages] = useState([]);
  const [progressData, setProgressData] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  const openProgressModal = (images, location) => {
    try {
      const parsedImages = JSON.parse(images || "[]");
      const parsedLocations = JSON.parse(location || "[]");

      let imageArray = [];

      parsedImages.forEach((img) => {
        try {
          const nested = JSON.parse(img);

          if (Array.isArray(nested)) {
            imageArray.push(...nested);
          } else {
            imageArray.push(img);
          }
        } catch {
          imageArray.push(img);
        }
      });

      const combinedData = imageArray.map((image, index) => {
        let locationObj = {};

        const loc = parsedLocations[index];

        if (loc && loc !== "na" && loc !== "null" && loc !== "") {
          try {
            locationObj = JSON.parse(loc);
          } catch (err) {
            console.error("Invalid location JSON:", loc, err);
          }
        }

        return {
          image,
          location: locationObj,
        };
      });

      // const combinedData = imageArray.map((image, index) => {
      //   let locationObj = {};

      //   try {
      //     locationObj = JSON.parse(parsedLocations[index] || "{}");
      //   } catch (err) {
      //     console.log(err);
      //   }

      //   return {
      //     image,
      //     location: locationObj,
      //   };
      // });

      console.log("combinedData", combinedData);

      setProgressData(combinedData);
      setShowProgressModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  const formatShortIndian = (num) => {
    num = Number(num);

    if (num >= 1e12) return (num / 1e12).toFixed(2) + " Lakh Cr";
    if (num >= 1e9) return (num / 1e9).toFixed(2) + " Arab";
    if (num >= 1e7) return (num / 1e7).toFixed(2) + " Cr";
    if (num >= 1e5) return (num / 1e5).toFixed(2) + " L";
    if (num >= 1e3) return (num / 1e3).toFixed(2) + " K";

    return num.toString();
  };

  const { RoleID } = JSON.parse(localStorage.getItem("admindetails")) || {};

  // Open the Bill Slip for a given Demand ID
  const openBillSlip = async (ID) => {
    if (!ID) return;   // addeddddddd
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setFetchSpecificDemandDeductionDetail(res);
      setSelectedDemandID(ID);

      const filtered = res.filter((val) => val.DemandGenerationID == ID);
      setSelectedBillData(filtered[0] || {});

      setPreviousSpecific(showspecific); // Addedddddddd
      setSpecific(3); // ✅ new sub-view for the bill slip
    } catch (err) {
      console.log(err);
    }
  };


  ////// Added for status
    const openVendorModal = async (demandID) => {
    console.log("openVendorModal clicked:", demandID);
  if (!demandID) {
    alert("Demand ID not found");
    return;
  }
  setVendorModalDemandID(demandID);
  setVendorModalData([]);
  setVendorModalLoading(true);
  setShowVendorModal(true);
  try {
    const res = await Getyears("FetchDemandDeductionDetailbyBillID", demandID);
    // Only vendor payment rows (not deduction rows)
const vendorRows = (res || []).filter(
  (val) =>
    String(val.DemandGenerationID) === String(demandID) &&
    String(val.TypeOfAmount || "").trim().toLowerCase() ===
      "total amount payable"
);
    setVendorModalData(vendorRows);
  } catch (err) {
    console.log(err);
  } finally {
    setVendorModalLoading(false);
  }
};
const closeVendorModal = () => {
  setShowVendorModal(false);
  setVendorModalData([]);
  setVendorModalDemandID("");
};



  const closeBillSlip = () => {
    setFetchSpecificDemandDeductionDetail([]);
    setSelectedBillData({});
    setSelectedDemandID(null);
    // setSpecific(1); // ✅ back to the Liability list
    setSpecific(previousSpecific); // ✅ go back to wherever you actually came from
  };

  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }
    setExportingBillSlipPDF(true);
    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;
      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo =
        selectedBillData?.DemandGenerationID || selectedDemandID;
      pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);
      alert("Failed to export bill slip PDF. Please try again.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };

  // ---- Liability table exports ----

  // const exportLiabilityToExcel = (filename = "Liability_Details.xlsx") => {
  //   const source = filtereddemand;
  //   if (!source?.length) {
  //     alert("No data available");
  //     return;
  //   }

  //   // const getStatus = (val) =>
  //   //   val.Approvance8 == "true" && val.Approvance9 == "true"
  //   //     ? "Fund release by BDS"
  //   //     : "Pending";
  //   const getStatus = (val) =>
  //     val.Account_Approval === "true" &&
  //       val.Admin_Approval === "true" &&
  //       val.General_Manager_Approval === "true"
  //       ? "Fund release by BDS"
  //       : "Pending";

  //   const excelData = source.map((val, index) => ({
  //     "Sr.No.": index + 1,
  //     "Project Name": val.ProjectName || "-",
  //     "Demand ID": val.DemandGenerationID || "-",
  //     "District": val.District || "-",
  //     "Bill Amount": Number(val.BillAmount || 0),
  //     "Payable Amount": Number(val.NetPayableAmount || 0),
  //     "Deduction Amount": Number(val.DeductionAmount || 0),
  //     Status: getStatus(val),
  //   }));

  //   const totals = source.reduce(
  //     (acc, val) => {
  //       acc.totalBillamount += Number(val.BillAmount || 0);
  //       acc.totalNetPayable += Number(val.NetPayableAmount || 0);
  //       acc.totalDeduction += Number(val.DeductionAmount || 0);
  //       return acc;
  //     },
  //     { totalBillamount: 0, totalNetPayable: 0, totalDeduction: 0 },
  //   );

  //   excelData.push({
  //     "Sr.No.": "",
  //     "Project Name": "",
  //     "Demand ID": "",
  //     "District": "TOTAL",
  //     "Bill Amount": totals.totalBillamount,
  //     "Payable Amount": totals.totalNetPayable,
  //     "Deduction Amount": totals.totalDeduction,
  //     Status: "",
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(excelData);

  //   worksheet["!cols"] = Object.keys(excelData[0]).map((key) => {
  //     const maxLength = Math.max(
  //       key.length,
  //       ...excelData.map((row) => String(row[key] ?? "").length),
  //     );
  //     return { wch: Math.min(Math.max(maxLength + 2, 14), 35) };
  //   });

  //   worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
  //   worksheet["!autofilter"] = {
  //     ref: XLSX.utils.encode_range({
  //       s: { r: 0, c: 0 },
  //       e: { r: excelData.length - 2, c: Object.keys(excelData[0]).length - 1 },
  //     }),
  //   };

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Liability");
  //   XLSX.writeFile(workbook, filename);
  // };

  const exportLiabilityToExcel = (filename = "Liability_Details.xlsx") => {
    let source = [...(filtereddemand || [])];
  
    if (!source.length) {
      alert("No data available");
      return;
    }
    if (selectedLiabilityStatus) {
      source = source.filter(
        (val) => getBillStatus(val) === selectedLiabilityStatus
      );
    }
    if (selectedDistricts && selectedDistricts.length > 0) {
      source = source.filter((val) =>
        selectedDistricts.includes(val.District)
      );
    }
    if (!source.length) {
      alert("No data available for the selected filter");
      return;
    }
    const excelData = source.map((val, index) => ({
      "Sr.No.": index + 1,
      "Project Name": val.ProjectName || "-",
      "Demand ID": val.DemandGenerationID || "-",
      District: val.District || "-",
      "Bill Amount": Number(val.BillAmount || 0),
      "Payable Amount": Number(val.NetPayableAmount || 0),
      "Deduction Amount": Number(val.DeductionAmount || 0),
      Status: getBillStatus(val),
    }));
    const totals = source.reduce(
      (acc, val) => {
        acc.totalBillamount += Number(val.BillAmount || 0);
        acc.totalNetPayable += Number(val.NetPayableAmount || 0);
        acc.totalDeduction += Number(val.DeductionAmount || 0);
  
        return acc;
      },
      {
        totalBillamount: 0,
        totalNetPayable: 0,
        totalDeduction: 0,
      }
    );
    excelData.push({
      "Sr.No.": "",
      "Project Name": "",
      "Demand ID": "",
      District: "TOTAL",
      "Bill Amount": totals.totalBillamount,
      "Payable Amount": totals.totalNetPayable,
      "Deduction Amount": totals.totalDeduction,
      Status: "",
    });
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    worksheet["!cols"] = Object.keys(excelData[0]).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...excelData.map((row) =>
          String(row[key] ?? "").length
        )
      );
  
      return {
        wch: Math.min(Math.max(maxLength + 2, 14), 35),
      };
    });
  
    // Freeze header
    worksheet["!freeze"] = {
      xSplit: 0,
      ySplit: 1,
    };
    worksheet["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: {
          r: excelData.length - 2,
          c: Object.keys(excelData[0]).length - 1,
        },
      }),
    };
    const workbook = XLSX.utils.book_new();
  
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Liability"
    );
  
    XLSX.writeFile(workbook, filename);
  };

  // const exportLiabilityToPDF = async (
  //   filename = "Liability_Details.pdf",
  //   title = "Liability Details",
  // ) => {
  //   const source = filtereddemand;
  //   if (!source?.length) {
  //     alert("No data available");
  //     return;
  //   }

  //   setExportingLiabilityPDF(true);

  //   try {
  //     const getStatus = (val) =>
  //       val.Approvance8 == "true" && val.Approvance9 == "true"
  //         ? "Fund release by BDS"
  //         : "Pending";

  //     const columns = [
  //       "Sr.No.",
  //       "Project Name",
  //       "Demand ID",
  //       "Bill Amount",
  //       "Payable Amount",
  //       "Deduction Amount",
  //       "Status",
  //     ];

  //     const exportTable = document.createElement("table");
  //     exportTable.style.borderCollapse = "collapse";
  //     exportTable.style.width = "max-content";
  //     exportTable.style.background = "#ffffff";
  //     exportTable.style.color = "#000000";
  //     exportTable.style.fontSize = "11px";

  //     const thead = document.createElement("thead");
  //     const headRow = document.createElement("tr");
  //     columns.forEach((label) => {
  //       const th = document.createElement("th");
  //       th.textContent = label;
  //       th.style.padding = "8px";
  //       th.style.border = "1px solid #ccc";
  //       th.style.background = "#2C78DB";
  //       th.style.color = "#ffffff";
  //       th.style.whiteSpace = "nowrap";
  //       headRow.appendChild(th);
  //     });
  //     thead.appendChild(headRow);
  //     exportTable.appendChild(thead);

  //     const tbody = document.createElement("tbody");
  //     let totalBill = 0,
  //       totalPayable = 0,
  //       totalDeduction = 0;

  //     source.forEach((val, index) => {
  //       const billAmt = Number(val.BillAmount || 0);
  //       const payableAmt = Number(val.NetPayableAmount || 0);
  //       const deductionAmt = Number(val.DeductionAmount || 0);
  //       totalBill += billAmt;
  //       totalPayable += payableAmt;
  //       totalDeduction += deductionAmt;

  //       const row = document.createElement("tr");
  //       [
  //         index + 1,
  //         val.ProjectName || "-",
  //         val.DemandGenerationID || "-",
  //         billAmt.toLocaleString("en-IN"),
  //         payableAmt.toLocaleString("en-IN"),
  //         deductionAmt.toLocaleString("en-IN"),
  //         getStatus(val),
  //       ].forEach((value) => {
  //         const td = document.createElement("td");
  //         td.textContent = String(value);
  //         td.style.padding = "8px";
  //         td.style.border = "1px solid #ccc";
  //         row.appendChild(td);
  //       });
  //       tbody.appendChild(row);
  //     });

  //     const totalRow = document.createElement("tr");
  //     const totalLabel = document.createElement("td");
  //     totalLabel.textContent = "Total";
  //     totalLabel.colSpan = 3;
  //     totalLabel.style.fontWeight = "bold";
  //     totalLabel.style.padding = "8px";
  //     totalLabel.style.border = "1px solid #ccc";
  //     totalRow.appendChild(totalLabel);

  //     [totalBill, totalPayable, totalDeduction].forEach((val) => {
  //       const td = document.createElement("td");
  //       td.textContent = val.toLocaleString("en-IN");
  //       td.style.fontWeight = "bold";
  //       td.style.padding = "8px";
  //       td.style.border = "1px solid #ccc";
  //       totalRow.appendChild(td);
  //     });

  //     const spacer = document.createElement("td");
  //     spacer.style.border = "1px solid #ccc";
  //     totalRow.appendChild(spacer);
  //     tbody.appendChild(totalRow);
  //     exportTable.appendChild(tbody);

  //     exportTable.style.position = "absolute";
  //     exportTable.style.left = "-99999px";
  //     exportTable.style.top = "0";
  //     exportTable.style.zIndex = "-1";
  //     document.body.appendChild(exportTable);

  //     await new Promise((resolve) => setTimeout(resolve, 100));

  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const topMargin = 18,
  //       sideMargin = 10,
  //       bottomMargin = 10;

  //     pdf.setFontSize(15);
  //     pdf.setFont("helvetica", "bold");
  //     pdf.text(title, pageWidth / 2, 10, { align: "center" });

  //     const canvas = await html2canvas(exportTable, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: "#ffffff",
  //       windowWidth: exportTable.scrollWidth,
  //     });

  //     const imgWidth = pageWidth - sideMargin * 2;
  //     const pxToMm = imgWidth / canvas.width;
  //     const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //     const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //     let renderedHeight = 0,
  //       pageNumber = 0;
  //     while (renderedHeight < canvas.height) {
  //       const sliceHeight = Math.min(
  //         usablePageHeightPx,
  //         canvas.height - renderedHeight,
  //       );
  //       const pageCanvas = document.createElement("canvas");
  //       const context = pageCanvas.getContext("2d");
  //       pageCanvas.width = canvas.width;
  //       pageCanvas.height = sliceHeight;
  //       context.drawImage(
  //         canvas,
  //         0,
  //         renderedHeight,
  //         canvas.width,
  //         sliceHeight,
  //         0,
  //         0,
  //         canvas.width,
  //         sliceHeight,
  //       );
  //       const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);
  //       if (pageNumber > 0) pdf.addPage();
  //       pdf.addImage(
  //         imgData,
  //         "JPEG",
  //         sideMargin,
  //         topMargin,
  //         imgWidth,
  //         sliceHeight * pxToMm,
  //       );
  //       renderedHeight += sliceHeight;
  //       pageNumber++;
  //     }

  //     pdf.save(filename);
  //     document.body.removeChild(exportTable);
  //   } catch (error) {
  //     console.error("Liability PDF Export Error:", error);
  //     alert("Failed to export PDF.");
  //   } finally {
  //     setExportingLiabilityPDF(false);
  //   }
  // };
const exportLiabilityToPDF = async (
  filename = "Liability_Details.pdf",
  title = "Liability Details"
) => {
  let source = [...(filtereddemand || [])];

  if (!source.length) {
    alert("No data available");
    return;
  }

  setExportingLiabilityPDF(true);

  let exportTable = null;

  try {
    if (selectedLiabilityStatus) {
      source = source.filter(
        (val) => getBillStatus(val) === selectedLiabilityStatus
      );
    }
    if (selectedDistricts && selectedDistricts.length > 0) {
      source = source.filter((val) =>
        selectedDistricts.includes(val.District)
      );
    }
    if (!source.length) {
      alert("No data available for the selected filter");
      return;
    }
    const uniqueData = [
      ...new Map(
        source
          .filter((val) => val.DemandGenerationID)
          .map((item) => [
            item.DemandGenerationID,
            item,
          ])
      ).values(),
    ];

    if (!uniqueData.length) {
      alert("No data available");
      return;
    }
    const columns = [
      "Sr.No.",
      "Project Name",
      "Demand ID",
      "District",
      "Bill Amount",
      "Payable Amount",
      "Deduction Amount",
      "Status",
    ];
    exportTable = document.createElement("table");

    Object.assign(exportTable.style, {
      width: "100%",
      tableLayout: "fixed",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff",
      color: "#000000",
      fontFamily: "Arial, Noto Sans Devanagari, sans-serif",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0",
      padding: "0",
    });
    const columnWidths = [
      "5%",
      "24%",
      "10%",
      "11%",
      "12%",
      "13%",
      "12%",
      "13%",
    ];
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");

    columns.forEach((label, index) => {
      const th = document.createElement("th");

      th.textContent = label;

      Object.assign(th.style, {
        width: columnWidths[index],
        padding: "10px 8px",
        border: "1px solid #ffffff",
        backgroundColor: "#2C78DB",
        color: "#ffffff",
        textAlign: "center",
        verticalAlign: "middle",
        fontSize: "18px",
        fontWeight: "600",
        lineHeight: "1.2",
        whiteSpace: "normal",
        wordBreak: "break-word",
      });

      headRow.appendChild(th);
    });

    thead.appendChild(headRow);
    exportTable.appendChild(thead);
    const tbody = document.createElement("tbody");

    let totalBill = 0;
    let totalPayable = 0;
    let totalDeduction = 0;

    uniqueData.forEach((val, index) => {
      const billAmt = Number(val.BillAmount || 0);
      const payableAmt = Number(val.NetPayableAmount || 0);
      const deductionAmt = Number(val.DeductionAmount || 0);

      totalBill += billAmt;
      totalPayable += payableAmt;
      totalDeduction += deductionAmt;

      const row = document.createElement("tr");

      row.style.backgroundColor =
        index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

      const values = [
        index + 1,
        val.ProjectName || "-",
        val.DemandGenerationID || "-",
        val.District || "-",
        billAmt.toLocaleString("en-IN"),
        payableAmt.toLocaleString("en-IN"),
        deductionAmt.toLocaleString("en-IN"),

        getBillStatus(val),
      ];

      values.forEach((value, cellIndex) => {
        const td = document.createElement("td");

        td.textContent = String(value);

        Object.assign(td.style, {
          width: columnWidths[cellIndex],
          padding: "8px 8px",
          borderBottom: "1px solid #d3d3d3",
          borderLeft: "none",
          borderRight: "none",
          borderTop: "none",
          fontSize: "18px",
          fontWeight: "500",
          lineHeight: "1.25",
          verticalAlign: "middle",
          textAlign: "center",
          wordBreak: "break-word",
          overflowWrap: "break-word",
        });

        // Project Name
        if (cellIndex === 1) {
          td.style.textAlign = "center";
        }

        // Amount columns
        if (cellIndex >= 4 && cellIndex <= 6) {
          td.style.whiteSpace = "nowrap";
        }

        row.appendChild(td);
      });

      tbody.appendChild(row);
    });
    const totalRow = document.createElement("tr");

    Object.assign(totalRow.style, {
      backgroundColor: "#cbd1d8",
      fontWeight: "bold",
      fontSize: "18px",
    });

    const totalLabel = document.createElement("td");

    totalLabel.textContent = "Total";
    totalLabel.colSpan = 4;

    Object.assign(totalLabel.style, {
      padding: "9px 8px",
      borderTop: "1px solid #999",
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "left",
    });

    totalRow.appendChild(totalLabel);

    [
      totalBill,
      totalPayable,
      totalDeduction,
    ].forEach((value) => {
      const td = document.createElement("td");

      td.textContent = value.toLocaleString("en-IN");

      Object.assign(td.style, {
        padding: "9px 8px",
        borderTop: "1px solid #999",
        fontWeight: "bold",
        fontSize: "18px",
        textAlign: "center",
        whiteSpace: "nowrap",
      });

      totalRow.appendChild(td);
    });

    // Empty status cell
    const emptyTotalCell = document.createElement("td");

    Object.assign(emptyTotalCell.style, {
      padding: "9px",
      borderTop: "1px solid #999",
    });

    totalRow.appendChild(emptyTotalCell);

    tbody.appendChild(totalRow);

    exportTable.appendChild(tbody);
    Object.assign(exportTable.style, {
      position: "absolute",
      left: "-100000px",
      top: "0",
      zIndex: "-9999",
    });

    document.body.appendChild(exportTable);

    await new Promise((resolve) => setTimeout(resolve, 300));
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const sideMargin = 10;
    const topMargin = 18;
    const bottomMargin = 10;
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(16);

    pdf.text(
      title,
      pageWidth / 2,
      10,
      {
        align: "center",
      }
    );
    const canvas = await html2canvas(exportTable, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      windowWidth: exportTable.scrollWidth,
      windowHeight: exportTable.scrollHeight,
    });

    const imgWidth = pageWidth - sideMargin * 2;

    const pxToMm = imgWidth / canvas.width;

    const usableHeightMm =
      pageHeight - topMargin - bottomMargin;

    const usableHeightPx =
      usableHeightMm / pxToMm;

    let renderedHeight = 0;
    let pageNumber = 0;

    while (renderedHeight < canvas.height) {
      const sliceHeight = Math.min(
        usableHeightPx,
        canvas.height - renderedHeight
      );

      const pageCanvas = document.createElement("canvas");

      const context = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = Math.ceil(sliceHeight);

      context.fillStyle = "#ffffff";

      context.fillRect(
        0,
        0,
        pageCanvas.width,
        pageCanvas.height
      );

      context.drawImage(
        canvas,
        0,
        renderedHeight,
        canvas.width,
        sliceHeight,
        0,
        0,
        canvas.width,
        sliceHeight
      );

      const imgData = pageCanvas.toDataURL(
        "image/jpeg",
        0.95
      );

      if (pageNumber > 0) {
        pdf.addPage();
      }

      pdf.addImage(
        imgData,
        "JPEG",
        sideMargin,
        topMargin,
        imgWidth,
        sliceHeight * pxToMm
      );

      renderedHeight += sliceHeight;
      pageNumber++;
    }
    pdf.save(filename);

  } catch (error) {
    console.error(
      "Liability PDF Export Error:",
      error
    );

    alert("Failed to export PDF.");

  } finally {
    if (exportTable && exportTable.parentNode) {
      exportTable.parentNode.removeChild(exportTable);
    }

    setExportingLiabilityPDF(false);
  }
};
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!progressData?.length) return;

      if (e.key === "ArrowRight") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex + 1) % progressData.length
        );
      }

      if (e.key === "ArrowLeft") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex - 1 + progressData.length) % progressData.length
        );
      }

      // Optional: close image/modal with Escape
      // if (e.key === "Escape") {
      //   setSelectedImageIndex(null);
      // }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progressData]);
  console.log(
    "currentdemands unique:",
    [
      ...new Map(
        (currentdemands || [])
          .filter(val => val.DemandGenerationID)
          .map(item => [item.DemandGenerationID, item])
      ).values()
    ]
  );
    console.log("filtereddemand unique:", [
    ...new Map(
      (filtereddemand || [])
        .filter(val => val.DemandGenerationID)
        .map(item => [item.DemandGenerationID, item])
    ).values()
  ]);

  // Added for the new status for each login display appropriate data
const getBillStatus = (val) => {
  const roleText = Object.values(userData || {})
    .filter((v) => typeof v === "string")
    .join(" ")
    .toLowerCase()
    .replace(/[^a-z]/g, "");

  const isChecker = /ch(e)?cker/.test(roleText);
  const isSectionOfficer = roleText.includes("sectionofficer");

  const a8 = String(val.Approvance8) === "true";
  const a9 = String(val.Approvance9) === "true";

  // Checker Officer -> Approvance8
  if (isChecker) return a8 ? "Approved" : "Pending";

  // Section Officer -> Approvance9
  if (isSectionOfficer) return a9 ? "Approved" : "Pending";

  // Any other login: final approval (CAFO = Approvance7)
  return String(val.Approvance7) === "true" ? "Approved" : "Pending";
};
// const getStatusLabel = (status) =>
//   status === "Approved" ? t("Released By BDS") : t(status);
const getStatusLabel = (status) => t(status);

  return (
    <>
      <div style={{ backgroundColor: "#dfdcf6" }}>
        {showspecific == 0 && (
          <div
            className="col-12 py-5"
            style={{ overflow: "auto", height: "90vh" }}
          >
            <div className="col-12">
              <div style={{ width: "96%" }} className="m-auto">
                <div
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      width: "17rem",
                      height: "6rem",
                      borderRadius: "10px",
                      background: "white",
                      padding: "10px",
                      boxShadow: "0px 0px 3px",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={TotalProjectCost}
                        style={{
                          width: "40px",
                          height: "40px",
                          marginRight: "10px",
                        }}
                      />
                      <div>
                        <h6
                          style={{
                            color: "darkgray",
                            margin: 0,
                            cursor: "pointer",
                          }}
                        >
                          {t("Liability")}
                        </h6>
                        <h5 style={{ margin: 0 }}>
                          {Number(liabilityData || 0).toLocaleString("en-IN")}
                        </h5>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "blue",
                        alignSelf: "flex-start",
                      }}
                    >
                      <p
                        style={{ margin: 0, cursor: "pointer" }}
                        onClick={() => setSpecific(1)}
                      >
                        {t("See Details")}
                      </p>
                    </div>
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      onClick={() => setSpecific(1)}
                    >
                      &rarr;
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "17rem",
                      height: "6rem",
                      borderRadius: "10px",
                      background: "white",
                      backdropFilter: "blur(52px)",
                      border: "1px solid #eee",
                      padding: "10px",
                      boxShadow: "0px 0px 3px",
                    }}
                  >
                    <img
                      src={AvailableBalance}
                      style={{
                        width: "40px",
                        height: "40px",
                        marginRight: "10px",
                      }}
                    />
                    <div>
                      <h6 style={{ color: "darkgray", margin: 0 }}>
                        {t("Available Balance in Bank")}
                      </h6>
                      <h5 style={{ margin: 0 }}>
                        {Number(TotalPaidCount).toLocaleString("en-IN") || 0}
                      </h5>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "blue",
                          alignSelf: "flex-start",
                        }}
                      >
                        <p
                          style={{ margin: 0, cursor: "pointer" }}
                          onClick={() => setSpecific(2)}
                        >
                          {t("See Details")}
                        </p>
                      </div>
                      <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "18px",
                          color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() => setSpecific(2)}
                      >
                        &rarr;
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "17rem",
                      height: "6rem",
                      borderRadius: "10px",
                      background: "white",
                      backdropFilter: "blur(52px)",
                      border: "1px solid #eee",
                      padding: "10px",
                      boxShadow: "0px 0px 3px",
                    }}
                  >
                    <img
                      src={ExcessShortfall64}
                      style={{
                        width: "40px",
                        height: "40px",
                        marginRight: "10px",
                      }}
                    />
                    <div>
                      <h6 style={{ color: "darkgray", margin: 0 }}>
                        {t("Excess/Shortfall")}
                      </h6>
                      <h5 style={{ margin: 0 }}>
                        ₹ {(0).toLocaleString("en-IN")}
                      </h5>
                      {/* <h5 style={{ margin: 0 }}>
                        ₹{" "}
                         {(
                           BankBalance.AvailableBalanceinBank - liabilityData
                         ).toLocaleString("en-IN")}
                       </h5> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 pb-2 pt-4">
              {/* <div className='m-auto' style={{ backgroundColor: "#EFF3F8", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}> */}

              <div
                className="col-12 pb-2"
                style={{ padding: "40px 40px", borderRadius: "20px" }}
              >
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <h5 className="my-auto fw-bold">
                      <img
                        src="/Details-64.png"
                        alt="Details"
                        style={{ width: "24px", height: "24px" }}
                        className="my-auto me-1"
                      />
                      <span className="my-auto ">{t("Project Details")}</span>
                    </h5>

                    {/* <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                      <select
                        value={selectedDistrict}
                        placeholder='Choose District'
                        onChange={(e) => setselectedDistrict(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 32px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          outline: "none"
                        }}>
                        <option value="" disabled>Select District</option>
                        {
                          AllDistrict &&
                          [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                            return (
                              <option key={index} value={district}>{district}</option>
                            )
                          })
                        }
                      </select>
                    </div> */}

                    {/* //////////// */}
                    <div style={{ position: "relative", width: "220px", marginRight: "10px" }}>
                      {/* <select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                        }}
                      >
                        <option value="">{t("Select Status")}</option>
                        <option value="Approved">{t("Approved")}</option>
                            <option value="Released By BDS">{t("Released By BDS")}</option>
                        <option value="Pending">{t("Pending")}</option>
                        <option value="Rejected">{t("Rejected")}</option>
                      </select> */}
                        <select
  value={selectedStatus}
  onChange={(e) => setSelectedStatus(e.target.value)}
  style={{
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "#f1f6fc",
      fontSize: "14px",
      color: "#333",
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
    }}
>
  <option value="">{t("Select Status")}</option>
  <option value="Pending">{t("Pending")}</option>
  <option value="Rejected">{t("Rejected")}</option>
  <option value="Released By BDS">{t("Released By BDS")}</option>
  {/* <option value="Sent to Bank">{t("Sent to Bank")}</option> */}
  <option value="Successful/Paid">{t("Successful/Paid")}</option>
</select>
                    </div>

                    <div
                      style={{
                        position: "relative",
                        width: "260px",
                        marginRight: "10px",
                      }}
                    >
                      <select
                        value={selectedType}
                        onChange={(e) => setselectedType(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px", // remove extra left padding
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                        }}
                      >
                        <option value="">Select Work Order Type</option>
                        <option value="Existing Work Order">
                          Existing Work Order
                        </option>
                        <option value="New Work Order">New Work Order</option>
                      </select>
                    </div>

                    {userData?.RoleID === 29 && (
                      <div
                        style={{
                          position: "relative",
                          width: "260px",
                          marginRight: "10px",
                        }}
                      >
                        <select
                          value={selectedHeadCode}
                          onChange={(e) => setSelectedHeadCode(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            backgroundColor: "#f1f6fc",
                            fontSize: "14px",
                            color: "#333",
                            appearance: "none",
                          }}
                        >
                          <option value="">Select Head Code</option>
                          <option value="3054">
                            3054-2419 (Roads and Bridge Repair Maintenance
                            Program)
                          </option>
                          <option value="2515">
                            2515-1238 (MLA Representative)
                          </option>
                        </select>
                      </div>
                    )}

                    <div
                      style={{
                        position: "relative",
                        width: "240px",
                        marginRight: "10px",
                      }}
                    >
                      {/* Trigger */}
                      <div
                        onClick={() => setOpen(true)}
                        style={{
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          cursor: "pointer",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {selectedDistricts.length > 0
                          ? selectedDistricts.join(", ")
                          : t("Select District")}
                      </div>

                      {/* Dropdown */}
                      {open && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                            zIndex: 9999,
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={toggleAllDistricts}
                              style={{ marginRight: "6px" }}
                            />
                            {t("All Districts")}
                          </label>
                          {/* List */}
                          <div
                            style={{ maxHeight: "180px", overflowY: "auto" }}
                          >
                            {allDistricts.map((district, index) => (
                              <label
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedDistricts.includes(district)}
                                  onChange={() =>
                                    handleCheckboxChange(district)
                                  }
                                  style={{ marginRight: "8px" }}
                                />
                                {district}
                              </label>
                            ))}
                          </div>

                          {/* OK button */}
                          <div
                            style={{
                              borderTop: "1px solid #eee",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            <button
                              onClick={() => setOpen(false)}
                              style={{
                                padding: "6px 14px",
                                borderRadius: "6px",
                                border: "none",
                                background: "#0d6efd",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: "13px",
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    <div style={{ position: "relative", width: "240px", marginRight: "10px" }}>
                      <select
                        placeholder='Choose Taluka'
                        value={selectedTaluka}
                        onChange={(e) => setselectedTaluka(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          outline: "none",
                        }}
                      >
                        <option value="">{t("Select Taluka")}</option>
                        {
                          TalukasofDistrict.length > 0 &&
                          TalukasofDistrict.map((val, index) => {
                            return (
                              <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                            )
                          })
                        }
                      </select>
                    </div>


                    <div
                      style={{
                        position: "relative",
                        width: "250px",
                        marginRight: "10px",
                      }}
                    >
                      <img
                        src="/Search32.png"
                        alt="Search Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          height: "16px",
                          opacity: 0.6,
                        }}
                      />
                      <input
                        type="text"
                        placeholder={t("Search Here")}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        value={searchTerm}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 32px", // left padding makes space for icon
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          outline: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="col-12 tableDesign"
                    style={{
                      background: "#2C78DB",
                      overflowX: "auto",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "600px", // change height as needed
                        position: "relative",
                        WebkitOverflowScrolling: "touch",
                      }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          minWidth: "1100px", // forces horizontal scroll on smaller screens
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead style={{
                          position: "sticky", backgroundColor: "#1976d2",
                          top: 0,
                          zIndex: 10,
                        }}>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={{ minWidth: "50px" }}>{t("Sr.No")}</th>
                            <th style={{ minWidth: "160px" }}>
                              {t("Work Name")}
                            </th>
                            <th style={{ width: "10%" }}>{t("Demand ID")}</th>
                            <th style={{ minWidth: "100px" }}>
                              {t("District")}
                            </th>
                            <th style={{ minWidth: "100px" }}>{t("Taluka")}</th>
                            <th style={{ minWidth: "150px" }}>
                              {t("Work order No")}
                            </th>
                            <th style={{ minWidth: "120px" }}>
                              {t("Work order Date")}
                            </th>
                            <th style={{ minWidth: "110px" }}>
                              {t("Physical Progress")}
                            </th>
                            <th style={{ minWidth: "150px" }}>
                              {t("Approved Work Order Amount")}
                            </th>
                            <th style={{ minWidth: "150px" }}>
                              {t("Bill Amount")}
                            </th>
                            <th style={{ minWidth: "150px" }}>
                              {t("Balance")}
                            </th>
                            <th style={{ width: "14%" }}>{t("Status")}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentBills?.length < 1 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                  fontSize: "18px",
                                }}
                              >
                                {t("No Data Found")}
                              </td>
                            </tr>
                          ) : (
                            currentBills.map((val, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                              return (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.WorkName}
                                  </td>
                                  {/* <td style={{ padding: '8px' }}>
  <span
    onClick={() => openBillSlip(val.DemandGenerationID)}
    style={{ color: "#0d6efd",  cursor: "pointer", fontWeight: 500 }}
  >
    {val.DemandGenerationID || "-"}
  </span>
</td> */}
                                  <td style={{ padding: '8px' }}>
                                    {val.DemandGenerationID ? (
                                      <span
                                        onClick={() => openBillSlip(val.DemandGenerationID)}
                                        style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer", fontWeight: 500 }}
                                      >
                                        {val.DemandGenerationID}
                                      </span>
                                    ) : (
                                      <span style={{ color: "#666", cursor: "default" }}>-</span>
                                    )}
                                  </td>
                                  {/* <td style={{ padding: "8px" }}>
                                    {val.talulka}
                                  </td> */}
                                  <td style={{ padding: "8px" }}>
                                    {(val.talulka || "").split("-")[0].trim() || "-"}
                                  </td>
                                  <td style={{ padding: "8px" }}>{val.ulb}</td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {val.WorkOrderNo || 0}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {val.WorkOrderDate
                                      ? new Date(
                                        val.WorkOrderDate,
                                      ).toLocaleDateString("en-GB", {
                                        timeZone: "Asia/Kolkata",
                                      })
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        openProgressModal(
                                          val.physicalprogressImage,
                                          val.Location,
                                        )
                                      }
                                    >
                                      {(val.physicalValue || 0).toLocaleString(
                                        "en-IN",
                                      )}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {Number(
                                      val.ApprovedWorkAmount || 0,
                                    ).toLocaleString("en-IN")}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {Number(
                                      val.BillPaidAmount || 0,
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td
                                    style={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {(
                                      Number(val.RemainingAmount || 0) -
                                      Number(val.BillPaidAmount || 0)
                                    ).toLocaleString("en-IN")}
                                  </td>
                                  {/* <td style={{ padding: "8px" }}>{val.Status}</td> */}
                                  {/* <td style={{ padding: "8px" }}>{getProjectStatus(val)}</td> */}
                                  {/* <td style={{ padding: "8px" }}>{getStatusLabel(getProjectStatus(val))}</td> */}

                                                            <td style={{ padding: "8px" }}>
                                                              {getProjectStatus(val) === "Successful/Paid" ? (
                                                                <span
                                                                  onClick={() => openVendorModal(val.DemandGenerationID)}
                                                                  style={{
                                                                    color: "#0d6efd",
                                                                    textDecoration: "underline",
                                                                    cursor: "pointer",
                                                                    fontWeight: 600,
                                                                  }}
                                                                >
                                                                  {getStatusLabel(getProjectStatus(val))}
                                                                </span>
                                                              ) : (
                                                                getStatusLabel(getProjectStatus(val))
                                                              )}
                                                            </td>
                                </tr>
                              );
                            })
                          )}

                          {filteredBills?.length > 0 &&
                            (() => {
                              const toNumber = (value) => {
                                const num = parseFloat(
                                  String(value ?? 0).replace(/,/g, ""),
                                );
                                return isNaN(num) ? 0 : num;
                              };

                              const pageTotals = currentBills.reduce(
                                (acc, val) => {
                                  acc.totalAvailable += Number(
                                    val.ApprovedWorkAmount || 0,
                                  );
                                  acc.totalBillPaid += Number(
                                    val.BillPaidAmount || 0,
                                  );
                                  acc.totalBalance +=
                                    Number(val.RemainingAmount || 0) -
                                    Number(val.BillPaidAmount || 0);
                                  return acc;
                                },
                                {
                                  totalAvailable: 0,
                                  totalBillPaid: 0,
                                  totalBalance: 0,
                                },
                              );

                              const totals = filteredBills.reduce(
                                (acc, val) => {
                                  acc.totalAvailable += toNumber(
                                    val.ApprovedWorkAmount,
                                  );
                                  acc.totalBillPaid += toNumber(
                                    val.BillPaidAmount,
                                  );
                                  acc.totalBalance +=
                                    toNumber(val.ApprovedWorkAmount) -
                                    toNumber(val.BillPaidAmount);
                                  return acc;
                                },
                                {
                                  totalAvailable: 0,
                                  totalBillPaid: 0,
                                  totalBalance: 0,
                                },
                              );

                              return (
                                <>
                                  <tr
                                    style={{
                                      backgroundColor: "#d9e1e9",
                                      fontSize: "18px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <td colSpan="8" style={{ padding: "8px" }}>
                                      {t("Page Total")}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {pageTotals.totalAvailable.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {pageTotals.totalBillPaid.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {pageTotals.totalBalance.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td></td>
                                  </tr>

                                  <tr
                                    style={{
                                      backgroundColor: "#d9e1e9",
                                      fontSize: "18px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <td colSpan="8" style={{ padding: "8px" }}>
                                      {t("Gross Total")}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {totals.totalAvailable.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {totals.totalBillPaid.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹{" "}
                                      {totals.totalBalance.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td></td>
                                  </tr>
                                </>
                              );
                            })()}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      height: "4rem",
                      alignItems: "center",
                    }}
                    className="mt-3"
                  >
                    <div>
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")}{" "}
                        {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                        {t("to ")}
                        {Math.min(indexofLastBill, filteredBills.length)}{" "}
                        {t("of")} {filteredBills.length} {t("entries")}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        )}

        {showspecific == 1 && (
          <div
            className="col-12"
            style={{
              backgroundColor: "#EFF3F8",
              height: "90vh",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12">
                <div className="col-12 text-start mb-4 mt-4 d-flex justify-content-between align-items-center flex-wrap">
                  <button
                    className="btn btn-danger px-3 rounded-4"
                    onClick={() => setSpecific(0)}
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true" />
                    {t(" Back")}
                  </button>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      disabled={exportingLiabilityPDF}
                      onClick={() =>
                        exportLiabilityToExcel("Liability_Details.xlsx")
                      }
                    >
                      {t("Download Excel")}
                    </button>
                    <button
                      className="btn btn-danger"
                      disabled={exportingLiabilityPDF}
                      onClick={() =>
                        exportLiabilityToPDF(
                          "Liability_Details.pdf",
                          "Liability Details",
                        )
                      }
                    >
                      {exportingLiabilityPDF
                        ? t("Exporting...")
                        : t("Download PDF")}
                    </button>
                  </div>
                </div>
                <div className="col-12 text-start mb-4 mt-4 d-flex justify-content-between align-items-center flex-wrap">
                  <div className="d-flex gap-2 align-items-center flex-wrap">
                    {/* Status filter */}
                    <select
                      value={selectedLiabilityStatus}
                      onChange={(e) => setSelectedLiabilityStatus(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      <option value="">{t("Select Status")}</option>
                      <option value="Approved">{t("Approved")}</option>
                      <option value="Pending">{t("Pending")}</option>
                      {/* <option value="Rejected">{t("Rejected")}</option> */}
                    </select>

                    {/* District (Division) filter */}
                    {/* <select
      value={selectedLiabilityDivision}
      onChange={(e) => setSelectedLiabilityDivision(e.target.value)}
      style={{
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "14px",
        color: "#333",
      }}
    >
      <option value="">{t("Select District")}</option>
      {allDivisions.map((division, index) => (
        <option key={index} value={division}>
          {division}
        </option>
      ))}
    </select> */}
                    <div style={{ position: "relative", width: "150px", marginRight: "10px" }}>
                      {/* Trigger */}
                      <div
                        onClick={() => setOpen(true)}
                        style={{
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          cursor: "pointer",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        {selectedDistricts.length > 0
                          ? selectedDistricts.join(", ")
                          : t("Select District")}
                      </div>

                      {/* Dropdown */}
                      {open && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                            zIndex: 9999
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              fontSize: "13px", whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={toggleAllDistricts}
                              style={{ marginRight: "6px" }}
                            />
                            {t("All Districts")}
                          </label>
                          {/* List */}
                          <div style={{ maxHeight: "180px", overflowY: "auto" }}>
                            {/* {[...new Set(AllDistrict.map(d => d.District_Marathi))].map(
          (district, index) => ( */}
                            {allDistricts.map(
                              (district, index) => (
                                <label
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px",
                                    cursor: "pointer",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedDistricts.includes(district)}
                                    onChange={() => handleCheckboxChange(district)}
                                    style={{ marginRight: "8px" }}
                                  />
                                  {district}
                                </label>
                              )
                            )}
                          </div>

                          {/* OK button */}
                          <div
                            style={{
                              borderTop: "1px solid #eee",
                              padding: "8px",
                              textAlign: "right"
                            }}
                          >
                            <button
                              onClick={() => setOpen(false)}
                              style={{
                                padding: "6px 14px",
                                borderRadius: "6px",
                                border: "none",
                                background: "#0d6efd",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: "13px"
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="col-12 tableDesign" style={{
                      overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative"
                    }}>
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          overflowX: "hidden",
                          overflowY: "scroll",
                        }}
                      >
                        <thead
                          style={{
                            background: '#2C78DB', overflowX: 'hidden', position: "sticky",
                            top: 0,
                            zIndex: 10
                          }}
                        >
                          <tr
                            style={{
                              width: "100%",
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <th style={{ width: "4%" }}>{t("Sr.No")}</th>
                            <th style={{ width: "10%" }}>
                              {t("Project Name")}
                            </th>
                            <th style={{ width: "10%" }}>{t("Demand ID")}</th>
                            <th style={{ width: "10%" }}>{t("District")}</th>
                            <th style={{ width: "10%" }}>{t("Bill Amount")}</th>
                            {/* <th style={{ width: "10%" }}>Type Of Amount</th> */}
                            <th style={{ width: "10%" }}>
                              {t("Net Payable Amount")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("Deduction Amount")}
                            </th>
                            <th style={{ width: "10%" }}>{t("Status")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentFilteredDemands &&
                            [
                              ...new Map(
                                currentFilteredDemands
                                  .filter((val) => val.DemandGenerationID)
                                  .map((item) => [
                                    item.DemandGenerationID,
                                    item,
                                  ]),
                              ).values(),
                            ].map((val, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <td style={{ padding: "4px 4px" }}>
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.ProjectName}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    <span
                                      onClick={() =>
                                        openBillSlip(val.DemandGenerationID)
                                      }
                                      style={{
                                        color: "#0d6efd",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {val.DemandGenerationID}
                                    </span>
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.District || "-"}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(val.BillAmount).toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  {/* <td style={{ padding: '8px' }}>{val.TypeOfAmount}</td> */}

                                  <td style={{ padding: "8px" }}>
                                    {Number(
                                      val.NetPayableAmount,
                                    ).toLocaleString("en-IN")}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(val.DeductionAmount).toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  {/* <td style={{ padding: "8px" }}>
                                    {val.Account_Approval == "true" &&
                                    val.Admin_Approval == "true" &&
                                    val.General_Manager_Approval == "true"
                                      ? "Approve"
                                      : "Pending"}
                                  </td> */}
                                  <td style={{ padding: "8px" }}>
                                    {getBillStatus(val)}
                                  </td>
                                </tr>
                              );
                            })}

                          {currentFilteredDemands &&
                            currentFilteredDemands.length > 0 &&
                            (() => {
                              const filteredUnique = [
                                ...new Map(
                                  currentFilteredDemands
                                    .filter((val) => val.DemandGenerationID)
                                    .map((item) => [
                                      item.DemandGenerationID,
                                      item,
                                    ]),
                                ).values(),
                              ];

                              const pageTotals = currentFilteredDemands.reduce(
                                (acc, val) => {
                                  acc.totalBillamount += Number(
                                    val.BillAmount || 0,
                                  );
                                  acc.totalNetPayable += Number(
                                    val.NetPayableAmount || 0,
                                  );
                                  acc.totalDeduction += Number(
                                    val.DeductionAmount || 0,
                                  );
                                  return acc;
                                },
                                {
                                  totalBillamount: 0,
                                  totalNetPayable: 0,
                                  totalDeduction: 0,
                                },
                              );

                              // const totals = filtereddemand.reduce(
                              const totals = filteredLiabilityDemand.reduce(
                                (acc, val) => {
                                  acc.totalBillamount += Number(
                                    val.BillAmount || 0,
                                  );
                                  acc.totalNetPayable += Number(
                                    val.NetPayableAmount || 0,
                                  );
                                  acc.totalDeduction += Number(
                                    val.DeductionAmount || 0,
                                  );
                                  return acc;
                                },
                                {
                                  totalBillamount: 0,
                                  totalNetPayable: 0,
                                  totalDeduction: 0,
                                },
                              );

                              return (
                                <>
                                  <tr
                                    style={{
                                      background: "#cbd1d8",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                    }}
                                  >
                                    <td colSpan={4} style={{ padding: "8px" }}>
                                      {t("Page Total")}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {pageTotals.totalBillamount.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {pageTotals.totalNetPayable.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {pageTotals.totalDeduction.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr
                                    style={{
                                      background: "#cbd1d8",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                    }}
                                  >
                                    <td colSpan={4} style={{ padding: "8px" }}>
                                      {t("Gross Total")}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {totals.totalBillamount.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {totals.totalNetPayable.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      ₹{" "}
                                      {totals.totalDeduction.toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td style={{ padding: "8px" }}></td>
                                  </tr>
                                </>
                              );
                            })()}
                        </tbody>
                      </table>
                    </div>

                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "25px 0",
                      }}
                    >
                      {/* <div>
                        <p
                          className="text-gray-600"
                          style={{
                            fontSize: "18px",
                            margin: 0,
                            fontSize: "18px",
                          }}
                        >
                          {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                          {Math.min(indexofLastBill, filtereddemand.length)}{" "}
                          {t("of")} {filtereddemand.length} {t("entries")}
                        </p>
                      </div> */}
 <div>
  <p className="text-gray-600" style={{ fontSize: "18px", margin: 0 }}>
    {t("Showing")}{" "}
    {filteredLiabilityDemand.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
    {t("to")}{" "}
    {Math.min(indexofLastBill, filteredLiabilityDemand.length)}{" "}
    {t("of")} {filteredLiabilityDemand.length} {t("entries")}
  </p>
</div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <GooglePagination
                          currentPage={currentPage}
                          // totalPages={totalPages1}
                          totalPages={totalPagesLiability}   // was totalPages1
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showspecific == 2 && (
          <div
            className="col-12"
            style={{
              backgroundColor: "#EFF3F8",
              height: "90vh",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12">
                <div className="col-12 text-start mb-4 mt-4">
                  <button
                    className="btn btn-danger px-3 rounded-4"
                    onClick={() => setSpecific(0)}
                  >
                    {" "}
                    <i class="fa fa-arrow-left" aria-hidden="true" /> Back
                  </button>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    <select
                      value={bankDistrict}
                      onChange={(e) => {
                        setBankDistrict(e.target.value);
                        setBankTaluka("");
                      }}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        cursor: "pointer",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginBottom: "15px"
                      }}
                    >
                      <option value="">All Districts</option>

                      {[...new Set(
                        availabeBalancinBank
                          ?.map(item => item.District)
                          .filter(Boolean)
                      )].map((district, index) => (
                        <option key={index} value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                    <select
                      value={bankTaluka}
                      onChange={(e) => setBankTaluka(e.target.value)}
                      disabled={!bankDistrict}
                      style={{
                        width: "220px",
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "14px",
                        color: "#333",
                        marginLeft: "10px"
                      }}
                    >
                      <option value="">All Talukas</option>

                      {[...new Set(
                        availabeBalancinBank
                          ?.filter(item => item.District === bankDistrict)
                          .map(item => item.Taluka)
                          .filter(Boolean)
                      )].map((taluka, index) => (
                        <option key={index} value={taluka}>
                          {taluka}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="Search anything..."
                      value={bankSearchTerm}
                      onChange={(e) => setBankSearchTerm(e.target.value)}
                      style={{
                        width: "220px",
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "14px",
                        marginLeft: "10px"
                      }}
                    />
                    <div
                      className="col-12 tableDesign"
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "600px", // change height as needed
                        position: "relative",
                      }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead
                          style={{
                            background: '#2C78DB', overflowX: "auto", width: "100%", position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                        >
                          <tr
                            style={{
                              width: "100%",
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <th style={{ width: "4%" }}>{t("Sr.No")}</th>
                            <th style={{ width: "10%" }}>{t("Release ID")}</th>
                            <th style={{ width: "10%" }}>{t("Financial")}</th>
                            <th style={{ width: "10%" }}>{t("District")}</th>
                            <th style={{ width: "10%" }}>{t("Taluka")}</th>
                            {/* <th style={{ width: "10%" }}>GR ID</th> */}
                            <th style={{ width: "20%" }}>
                              {t("Proposal Name")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("Project Cost")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("Original Limit")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("Release Amount")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("Available Limit")}
                            </th>
                          </tr>
                        </thead>
                        {currentbalance &&
                          currentbalance.map((val, index) => {
                            let TotalReleasedAmount = Number(
                              val.OriginalLimitAllocatedAmount -
                              val.LimitAllottedAmount,
                            );
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tbody>
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <td style={{ padding: "4px 4px" }}>
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.ReleaseID}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.FinancialYear}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.District}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {val.Taluka}
                                  </td>
                                  {/* <td style={{ padding: '8px' }}>{val.GRID}</td> */}
                                  <td style={{ padding: "8px" }}>
                                    {val.ProposalID}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(val.ProposalCost).toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(
                                      val.OriginalLimitAllocatedAmount,
                                    ).toLocaleString("en-IN")}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(TotalReleasedAmount).toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {Number(
                                      val.LimitAllottedAmount,
                                    ).toLocaleString("en-IN")}{" "}
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}

                        {filteredBankBalance &&
                          filteredBankBalance.length > 0 &&
                          (() => {
                            const pageTotals = currentbalance.reduce(
                              (acc, val) => {
                                let TotalReleasedAmount = Number(
                                  val.OriginalLimitAllocatedAmount -
                                  val.LimitAllottedAmount,
                                );

                                acc.totalCost += Number(val.ProposalCost || 0);
                                acc.totalOriginReleased += Number(
                                  val.OriginalLimitAllocatedAmount || 0,
                                );
                                acc.totalReleased += Number(
                                  TotalReleasedAmount || 0,
                                );
                                acc.totalLimit += Number(
                                  val.LimitAllottedAmount || 0,
                                );

                                return acc;
                              },
                              {
                                totalCost: 0,
                                totalOriginReleased: 0,
                                totalReleased: 0,
                                totalLimit: 0,
                              },
                            );
                            const totals = filteredBankBalance.reduce(
                              (acc, val) => {
                                let TotalReleasedAmount = Number(
                                  val.OriginalLimitAllocatedAmount -
                                  val.LimitAllottedAmount,
                                );
                                acc.totalCost += Number(val.ProposalCost || 0);
                                acc.totalOriginReleased += Number(
                                  val.OriginalLimitAllocatedAmount || 0,
                                );
                                acc.totalReleased += Number(
                                  TotalReleasedAmount || 0,
                                );
                                acc.totalLimit += Number(
                                  val.LimitAllottedAmount || 0,
                                );

                                return acc;
                              },
                              {
                                totalCost: 0,
                                totalOriginReleased: 0,
                                totalReleased: 0,
                                totalLimit: 0,
                              },
                            );

                            return (
                              <>
                                <tr
                                  style={{
                                    background: "#e2e8f0",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <td
                                    colSpan={6}
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {t("Page Total")}
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {pageTotals.totalCost.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {pageTotals.totalOriginReleased.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {pageTotals.totalReleased.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {pageTotals.totalLimit.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    background: "#e2e8f0",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <td
                                    colSpan={6}
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {t("Gross Total")}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    ₹ {totals.totalCost.toLocaleString("en-IN")}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {totals.totalOriginReleased.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {totals.totalReleased.toLocaleString(
                                      "en-IN",
                                    )}
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    ₹{" "}
                                    {totals.totalLimit.toLocaleString("en-IN")}
                                  </td>
                                </tr>
                              </>
                            );
                          })()}
                      </table>
                      {/* <div className='col-12 text-white' style={{ backgroundColor: "#0094DE" }}>
                    <p className='col-11 text-end py-2 fw-bold'>11,00,00,000.00</p>
                  </div> */}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "18px" }}
                        >
                          {t("Showing")}{" "}
                          {filteredBankBalance.length > 0
                            ? indexOfFirstBill + 1
                            : 0}{" "}
                          {t("to ")}
                          {Math.min(
                            indexofLastBill,
                            filteredBankBalance.length,
                          )}{" "}
                          {t("of")} {filteredBankBalance.length} {t("entries")}
                        </p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages2}
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showspecific === 3 && (
          <div className="col-12 m-auto">
            <div
              className="col-12 m-auto my-15 mb-10 budgetContainer"
              style={{
                maxHeight: "85vh",
                overflowY: "auto",
                overflowX: "hidden",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <div className="m-auto budgetElement">
                <div
                  className="mt-3 d-flex justify-content-between"
                  style={{
                    position: "relative",
                    alignItems: "center",
                    background: "#fff",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <img
                      src="/Bill-files64.png"
                      alt="Bill Slip"
                      width="26"
                      height="26"
                    />
                    <h5 className="m-0 fw-bold">Bill Slip</h5>
                  </div>

                  <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-primary d-flex align-items-center gap-2"
                      style={{
                        borderRadius: "999px",
                        padding: "6px 22px",
                        fontSize: "14px",
                        zIndex: 10,
                      }}
                      onClick={exportBillSlipPDF}
                      disabled={exportingBillSlipPDF}
                    >
                      {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
                    </button>

                    <button
                      className="btn btn-danger d-flex align-items-center gap-2"
                      style={{
                        borderRadius: "999px",
                        padding: "6px 22px",
                        fontSize: "14px",
                        zIndex: 10,
                      }}
                      onClick={closeBillSlip}
                    >
                      {t("Back")}
                    </button>
                  </div>
                </div>

                <div ref={billSlipRef}>
                  <div
                    className="text-center text-white py-3"
                    style={{
                      background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                    }}
                  >
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Zila Parishad - {selectedBillData.District}
                    </div>
                  </div>

                  <div className="border border-dark p-1">
                    <table
                      className="table mb-0"
                      style={{ fontSize: "14px", border: "none" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan={2}
                            className="fw-bold text-center fs-6 p-1"
                          >
                            Bill Slip for RDD
                          </td>
                        </tr>

                        {[
                          [
                            "User Name",
                            `${selectedBillData.UploadedBy ?? "-"}`,
                          ],
                          [
                            "Demand ID",
                            `${selectedBillData.DemandGenerationID ?? "-"}`,
                          ],
                          [
                            "Bill Creation Date",
                            selectedBillData.UploadedOn
                              ?
                              formatDateTime(selectedBillData.UploadedOn)
                              : "-",
                          ],
                          ["Head Code", `${selectedBillData.BudgetID ?? "-"}`],
                          ["Work Name", `${selectedBillData.ProjectID ?? "-"}`],
                          [
                            "Class of Work",
                            `${selectedBillData.classOfWork || selectedBillData.workClass || "-"}`,
                          ],
                          [
                            "Work Approved Year",
                            `${selectedBillData.ProposalYear ?? "-"}`,
                          ],
                          [
                            "Work order date",
                            selectedBillData.WorkOrderDate
                              ?
                              formatDate(selectedBillData.WorkOrderDate)
                              : "-",
                          ],
                          [
                            "Work Approved Amount",
                            `${selectedBillData.ApprovedWorkAmount ?? "-"}`,
                          ],
                          [
                            "Gross Bill Amount",
                            `${selectedBillData.BillAmount ?? "-"}`,
                          ],
                          [
                            "R.A.Bill No:",
                            `${selectedBillData.RABillNumber ?? "-"}`,
                          ],
                          [
                            "Invoice Bill No",
                            `${selectedBillData.InvoiceNo ?? "-"}`,
                          ],
                        ].map(([label, value], index) => (
                          <tr
                            key={index}
                            style={{ border: "1.5px solid #1190CA" }}
                          >
                            <td
                              className="text-start"
                              style={{
                                width: "30%",
                                backgroundColor: "#EAF3FB",
                                fontWeight: 500,
                                padding: "6px 10px",
                                borderRight: "1.5px solid #1190CA",
                              }}
                            >
                              {label}
                            </td>
                            <td
                              className="text-start"
                              style={{
                                width: "70%",
                                padding: "6px 10px",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              {value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <table
                      className="mt-1"
                      style={{
                        borderCollapse: "collapse",
                        border: "1px solid #000",
                      }}
                    >
                      <tbody>
                        <tr className="border border-dark">
                          <td
                            className="text-start border border-dark"
                            style={{ width: "30%" }}
                          >
                            Bill Amount
                          </td>
                          <td
                            className="text-start border border-dark"
                            style={{ width: "23%" }}
                          >
                            Deduction Amount
                          </td>
                          <td
                            className="text-start border border-dark"
                            style={{ width: "24%" }}
                          >
                            Net Payable
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start border border-dark">
                            {selectedBillData.BillAmount}
                          </td>
                          <td className="text-start border border-dark">
                            {selectedBillData.DeductionAmount}
                          </td>
                          <td className="text-start border border-dark">
                            {selectedBillData.NetPayableAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table
                      className="mt-2"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                      }}
                    >
                      <tbody>
                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            backgroundColor: "#EAF3FB",
                          }}
                        >
                          <td
                            colSpan="6"
                            style={{
                              padding: "8px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                            }}
                          >
                            Vendor Details
                          </td>
                        </tr>
                        <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Vendor Name
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            IFSC Code
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Branch Name
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Bank Name
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Account Number
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Amount
                          </td>
                        </tr>

                        {fetchSpecificDemandDeductionDetail
                          ?.filter(
                            (val) => val.TypeOfAmount == "Total Amount Payable",
                          )
                          .map((val, index) => (
                            <tr
                              style={{ border: "1.5px solid #1190CA" }}
                              key={index}
                            >
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.Vendor_Company_Name}
                              </td>
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.Bank_IFSC_Code}
                              </td>
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.Branch_Name}
                              </td>
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.BANK_NAME}
                              </td>
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.Bank_Account_Number}
                              </td>
                              <td
                                style={{
                                  padding: "6px 8px",
                                  backgroundColor: "white",
                                }}
                              >
                                {val.TotalAmount}
                              </td>
                            </tr>
                          ))}

                        <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                            style={{
                              padding: "6px 8px",
                              backgroundColor: "#EAF3FB",
                              fontWeight: 500,
                            }}
                            colSpan={5}
                          >
                            Total
                          </td>
                          <td className="border border-dark">
                            {selectedBillData.NetPayableAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table
                      className="my-2"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            backgroundColor: "#EAF3FB",
                          }}
                        >
                          <td
                            colSpan="6"
                            style={{
                              padding: "8px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                            }}
                          >
                            Deduction Amount Details
                          </td>
                        </tr>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                          }}
                        >
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Sr No
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Deduction Type
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Deduction Amount
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Account Number
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Bank Name
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            IFSC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fetchSpecificDemandDeductionDetail.filter(
                          (val) => val.TypeOfAmount != "Total Amount Payable",
                        )?.length == 0 ? (
                          <tr>
                            <td
                              colSpan="30"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        ) : (
                          fetchSpecificDemandDeductionDetail
                            .filter(
                              (val) =>
                                val.TypeOfAmount != "Total Amount Payable",
                            )
                            .map((row, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  key={index}
                                  style={{
                                    borderBottom: "1px solid #3b409e",
                                    backgroundColor: bgColor,
                                    fontSize: "13px",
                                  }}
                                >
                                  <td style={{ padding: "5px" }}>
                                    {index + 1}
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    {row.TypeOfAmount}
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    {row.TotalAmount}
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    {row.Bank_Account_Number}
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    {row.Bank_Name}
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    {row.Bank_IFSC_Code}
                                  </td>
                                </tr>
                              );
                            })
                        )}
                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            fontWeight: 600,
                            background: "white",
                          }}
                        >
                          <td
                            colSpan="2"
                            style={{ padding: "6px 8px", textAlign: "right" }}
                          >
                            Total
                          </td>
                          <td style={{ padding: "6px 8px" }}>
                            {selectedBillData.DeductionAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={footerTitleStyle}>
                      <tbody>
                        <tr>
                          <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={remarksTableStyle}>
                      <tbody>
                        <tr>
                          <td style={remarksTableTdStyle}>
                            प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत
                            करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च
                            करण्यात येणार आहे.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={remarksTableStyle}>
                      <tbody>
                        <tr>
                          <td style={remarksTableTdStyle}>
                            स्वाक्षरी आहरण व संवितरण अधिकारी
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={instructionTableStyle}>
                      <tbody>
                        <tr>
                          <td style={instructionTableTdStyle}>
                            दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे
                            प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या
                            अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात
                            नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी
                            ग्रामविकास विभाग मुबई येथे सादर करण्यात आले नव्हते.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressData?.length > 0 ? (
                    progressData.map((item, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "10px",
                            background: "#fff",
                          }}
                        >
                          {/* <img
                            src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
                            alt="progress"
                            className="img-fluid rounded"
                            style={{
                              width: "100%",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              setSelectedImageIndex(index);
                              setShowImageModal(true);
                            }}
                          /> */}
                          <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
  }}
>
  <img
    src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
    alt="progress"
    style={{
      display: "block",
      maxWidth: "100%",
      maxHeight: "250px",
      objectFit: "contain",
      borderRadius: "12px",
      padding: "8px",
      background: "#fff",
      boxShadow: "0 5px 18px rgba(0, 0, 0, 0.18)",
      cursor: "pointer",
      transition: "all 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.03)";
      e.currentTarget.style.boxShadow =
        "0 8px 25px rgba(0, 0, 0, 0.28)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow =
        "0 5px 18px rgba(0, 0, 0, 0.18)";
    }}
    onClick={() => {
      setSelectedImageIndex(index);
      setShowImageModal(true);
    }}
  />
</div>
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "14px",
                              lineHeight: "1.7",
                            }}
                          >
                            <div>
                              📍 <strong>Latitude:</strong>{" "}
                              {item.location?.latitude || "-"}
                            </div>

                            <div>
                              📍 <strong>Longitude:</strong>{" "}
                              {item.location?.longitude || "-"}
                            </div>

                            <div>
                              📅 <strong>Date:</strong>{" "}
                              {formatDate(item.location?.date) || "-"}
                            </div>

                            <div>
                              🕒 <strong>Time:</strong>{" "}
                              {item.location?.time || "-"}
                            </div>

                            <div>
                              ⛰️ <strong>Elevation:</strong>{" "}
                              {item.location?.elevation || "-"} m
                            </div>

                            <div>
                              🎯 <strong>Accuracy:</strong>{" "}
                              {item.location?.accuracy || "-"} m
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();

              const prevIndex =
                (selectedImageIndex - 1 + progressData.length) %
                progressData.length;

              setSelectedImageIndex(prevIndex);
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              cursor: "pointer",
            }}
          >
            ❮
          </button>
          <img
            src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />

          <button
            onClick={() => setShowImageModal(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            ×
          </button>
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              padding: "6px 12px",
              borderRadius: "20px",
            }}
          >
            {selectedImageIndex + 1} / {progressData.length}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();

              const nextIndex = (selectedImageIndex + 1) % progressData.length;

              setSelectedImageIndex(nextIndex);
            }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❯
          </button>
        </div>
      )}

{/* //////////Addded for status for successfull/paid */}
  {showVendorModal && (
  <div
    onClick={closeVendorModal}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 20000,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        background: "#fff",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "900px",
        maxHeight: "85vh",
        overflowY: "auto",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h5 style={{ margin: 0 }}>
          {t("Vendor Details")} - {vendorModalDemandID}
        </h5>
        <button
          onClick={closeVendorModal}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "28px",
            cursor: "pointer",
            lineHeight: 1,
          }}
        >
          ×
        </button>
      </div>

      {vendorModalLoading ? (
        <p style={{ textAlign: "center" }}>{t("Loading...")}</p>
      ) : vendorModalData.length === 0 ? (
        <p style={{ textAlign: "center" }}>{t("No Data Found")}</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{ width: "100%", borderCollapse: "collapse", fontSize: "15px" }}
          >
            <thead>
              <tr style={{ backgroundColor: "#1190CA", color: "white" }}>
                <th style={{ padding: "8px" }}>{t("Sr.No")}</th>
                <th style={{ padding: "8px" }}>{t("Vendor Name")}</th>
                <th style={{ padding: "8px" }}>{t("Bank Name")}</th>
                <th style={{ padding: "8px" }}>{t("Account Number")}</th>
                <th style={{ padding: "8px" }}>{t("IFSC Code")}</th>
                <th style={{ padding: "8px" }}>{t("Type Of Amount")}</th>
                <th style={{ padding: "8px" }}>{t("UTR NO.")}</th>
              </tr>
            </thead>
            <tbody>
              {vendorModalData.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                  }}
                >
                  <td style={{ padding: "8px" }}>{index + 1}</td>
                  <td style={{ padding: "8px" }}>{row.Vendor_Company_Name || "-"}</td>
                  <td style={{ padding: "8px" }}>{row.BANK_NAME || row.Bank_Name || "-"}</td>
                  <td style={{ padding: "8px" }}>{row.Bank_Account_Number || "-"}</td>
                  <td style={{ padding: "8px" }}>{row.Bank_IFSC_Code || "-"}</td>
                  <td style={{ padding: "8px" }}>{row.TypeOfAmount || "-"}</td>
                  <td style={{ padding: "8px" }}>{row.UTR_JNO_INSTNO || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ textAlign: "right", marginTop: "15px" }}>
        <button className="btn btn-danger" onClick={closeVendorModal}>
          {t("Close")}
        </button>
      </div>
    </div>
  </div>
)}


    </>
  );
};

export default ProjectDashboard;

// import React, { useContext, useEffect, useState } from "react";
// import AdminContext from "../../../admin/StateContext/Application";
// import ReactApexChart from "react-apexcharts";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "./page.css";
// import { apiurl } from "../../../../path";
// import {
//   Approved32,
//   AvailableBalance,
//   Click32,
//   Disable32,
//   Earnings,
//   Earningss,
//   Earningsss,
//   Error32,
//   ExcessShortfall64,
//   fifth,
//   first,
//   forth,
//   Graph64,
//   MoreMenu64,
//   NewTasks64,
//   Sales,
//   Second,
//   Spendthismonth64,
//   third,
//   TotalProjectCost,
//   TotalProjects64,
//   Unclick32,
//   YourBalance,
// } from "../../../../public/LoginImages/importimages";
// import "../../../Users/pages/innercss.css";
// import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
// import GooglePagination from '../../styles/GooglePagination';

// const ProjectDashboard = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const content = useContext(AdminContext);
//   const {
//     GetTaxAmounts,
//     GetVendorBills,
//     getTaxAmountsByDate,
//     GetDateWiseData,
//     GetProjectTotal,
//     GetTotalAmountAvailbaleInBank,
//     GetLiabilityTotal,
//     GetProjectInfo,
//     GetBudgetHeadInfo,
//   } = content;
//   const [getData, SetData] = useState({});
//   const [vendorbills, setVendorBills] = useState([]);
//   const [taxesData, SetTaxesData] = useState({});
//   const [loading, setloading] = useState(true);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [dateData, setDateData] = useState([]);
//   const [projectdata, setProjectData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [liabilityData, setLiabilityData] = useState([]);
//   const [BankBalance, setBankBalance] = useState([]);
//   const [demandList, setDemandList] = useState();
//   const [showspecific, setSpecific] = useState(0);
//   const [availabeBalancinBank, setAvailabeBalancinBank] = useState([]);
//   const [CountBalance, setCountBalance] = useState([]);
//   const [newData, setNewData] = useState([]);
//   const [selectedType, setselectedType] = useState("");
//   const billsPerPage = 10; // this will show entries

//   const [filteredBills, setFilteredBills] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const totalPages = Math.ceil(filteredBills.length / billsPerPage);
//   const indexofLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexofLastBill - billsPerPage;
//   const currentBills = filteredBills.slice(indexOfFirstBill, indexofLastBill);
//   const [AllDistrict, setAllDistrict] = useState([]);
//   const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
//   const [selectedDistrict, setselectedDistrict] = useState("");
//   const [selectedTaluka, setselectedTaluka] = useState("");

//   const [filtereddemand, setFiltereddemands] = useState([]);
//   const totalPages1 = Math.ceil(filtereddemand.length / billsPerPage);
//   const totalPages2 = Math.ceil(availabeBalancinBank.length / billsPerPage);
//   const currentdemands = filtereddemand.slice(
//     indexOfFirstBill,
//     indexofLastBill,
//   );
//   const currentbalance = availabeBalancinBank.slice(
//     indexOfFirstBill,
//     indexofLastBill,
//   );
//   const [selectedDistricts, setSelectedDistricts] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [data, setData] = useState({
//     ProjectName: "",
//     ProjectID: "",
//     PIU: "",
//     AvaiableReleaseAmount: 0,
//     SelectedDemandAmount: 0,
//     Balance: 0,
//   });

//   useEffect(() => {
//     GetAmountOfTaxes();
//     getVendorbill();
//     getTaxesAmountbyDate();
//     GetAllProjectTotal();
//     GetTotalAmountAvailableInBank();
//     GetLiabilityTotalAmount();
//   }, []);

//   const GetAmountOfTaxes = async () => {
//     let data = await GetTaxAmounts();
//     console.log(data);
//     SetData((prevState) => {
//       return data;
//     });
//     setloading(false);
//   };

//   const GetAllProjectTotal = async () => {
//     let data = await GetProjectTotal();
//     console.log("projectdata", data);
//     setProjectData(data);
//     setTableData(data);
//     setNewData(data);
//     setFilteredBills(data || []);
//     // setloading(false);
//   };

//   const TotalAmount = () => {
//     const totalAvaiablereleaseAmount = tableData.reduce(
//       (acc, item) => acc + Number(item.EsitmateAmount),
//       0,
//     );

//     setData((prev) => ({
//       ...prev,
//       AvaiableReleaseAmount: totalAvaiablereleaseAmount,
//     }));
//   };

//   useEffect(() => {
//     TotalAmount();
//   }, [tableData]);

//   // useEffect(() => {
//   //   const lowerSearchTerm = searchTerm.toLowerCase();
//   //   const filtered = newData?.filter(item =>
//   //     Object.values(item || {}).some(val =>
//   //       (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//   //     )
//   //   );
//   //   setFilteredBills(filtered || []);
//   //   setCurrentPage(1);
//   // }, [newData, searchTerm]);

//   // useEffect(() => {
//   //   if (selectedDistrict) {
//   //     const filtered = newData?.filter((item) => item.District === selectedDistrict);
//   //     setFilteredBills(filtered || []);
//   //     setCurrentPage(1);
//   //   }
//   // }, [selectedDistrict]);

//   // useEffect(() => {
//   //   if (selectedTaluka) {
//   //     const filtered = newData?.filter((item) => item.District === selectedDistrict && item.Taluka === selectedTaluka);
//   //     setFilteredBills(filtered || []);
//   //     setCurrentPage(1);
//   //   }
//   // }, [selectedTaluka]);

//   useEffect(() => {
//     setselectedTaluka("");
//   }, [selectedDistricts]);

//   // useEffect(() => {
//   //   let filtered = newData;

//   //   if (selectedDistricts.length > 0) {
//   //     filtered = filtered.filter((item) =>
//   //       selectedDistricts.includes(item.District),
//   //     );
//   //   }

//   //   if (selectedTaluka) {
//   //     filtered = filtered.filter((item) => item.Taluka == selectedTaluka);
//   //   }

//   //   if (selectedType) {
//   //     filtered = filtered.filter(item => item.WorkOrderType == selectedType);
//   //   }

//   //   if (searchTerm.trim() !== "") {
//   //     const lower = searchTerm.toLowerCase();
//   //     filtered = filtered.filter((bill) =>
//   //       Object.values(bill).some((val) =>
//   //         (val || "").toString().toLowerCase().includes(lower),
//   //       ),
//   //     );
//   //   }

//   //   setFilteredBills(filtered);
//   //   setCurrentPage(1);
//   // }, [searchTerm, newData, selectedDistrict, selectedTaluka,selectedType]);

//   const getVendorbill = async () => {
//     let data1 = await GetVendorBills();
//     setVendorBills(data1);
//     // setloading(false);
//   };
//   let vendorBillList = [];
//   if (vendorbills.length > 0) {
//     vendorBillList = vendorbills;
//   }

//   const GetTotalAmountAvailableInBank = async () => {
//     let data = await GetTotalAmountAvailbaleInBank();
//     console.log("Balank Detail 0---------------------", data);
//     setBankBalance(data[0]);
//     // setCountBalance(data.result1[0])
//   };
//   // let TotalPaidCount = BankBalance.AvailableBalanceinBank - CountBalance.SendAmountToVender

//   let TotalPaidCount = BankBalance.AvailableBalanceinBank;
//   console.log(TotalPaidCount);
//   const GetLiabilityTotalAmount = async () => {
//     let data = await GetLiabilityTotal();
//     console.log(data);
//     setLiabilityData(data[0]);
//   };
//   const getTaxesAmountbyDate = async () => {
//     let data = await getTaxAmountsByDate();
//     console.log(data);
//   };
//   const FetchDemandList = async () => {
//     try {
//       let res = await GetProjectInfo("", "");
//       let res1 = await GetProjectInfo("", "avaiableInBank");
//       console.log("Data if get ting ::", res1);
//       setDemandList(res);
//       console.log("Dmeand list data i ge t __________", res);
//       setAvailabeBalancinBank(res1);
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   useEffect(() => {
//     FetchDemandList();
//   }, []);

//   //For the Duplicacy of bill data
//   useEffect(() => {
//     if (demandList) {
//       const filteredUnique = [
//         ...new Map(
//           demandList
//             .filter((val) => val.DemandGenerationID)
//             .map((item) => [item.DemandGenerationID, item]),
//         ).values(),
//       ];

//       const totalBillAmount = filteredUnique.reduce((sum, item) => {
//         return sum + Number(item.BillAmount || 0);
//       }, 0);

//       console.log("Total Bill Amount:", totalBillAmount);
//       setLiabilityData(totalBillAmount);
//       setFiltereddemands(filteredUnique);
//     }
//   }, [demandList]);

//   // useEffect(() => {
//   //   if (selectedDistrict) {
//   //     let res = AllDistrict.filter((item) => item.District_Marathi === selectedDistrict);
//   //     setTalukasofDistrict(res);
//   //   }
//   // }, [selectedDistrict]);

//   const FetchData = async () => {
//     try {
//       let res1 = await GetBudgetHeadInfo("null", "AllDistrict");
//       setAllDistrict(res1);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchData();
//   }, []);

//   useEffect(() => {
//     if (selectedDistricts?.length > 0) {
//       console.log("sele", selectedDistricts);
//       const res = AllDistrict.filter((item) =>
//         selectedDistricts.includes(item.District_Marathi),
//       );
//       if (selectedDistricts.length > 1) {
//         setTalukasofDistrict([]);
//       } else {
//         setTalukasofDistrict(res);
//       }
//     } else {
//       setTalukasofDistrict([]); // optional: clear when nothing selected
//     }
//   }, [selectedDistricts, AllDistrict]);

//   useEffect(() => {
//     let filtered = newData;

//     if (selectedDistricts.length > 0) {
//       filtered = filtered.filter((item) =>
//         selectedDistricts.includes(item.District),
//       );
//     }

//     if (selectedTaluka) {
//       filtered = filtered.filter((item) => item.Taluka === selectedTaluka);
//     }

//     if (selectedType) {
//       filtered = filtered.filter(item => item.WorkOrderType == selectedType);
//     }

//     if (searchTerm.trim() !== "") {
//       const lower = searchTerm.toLowerCase();
//       filtered = filtered.filter((bill) =>
//         Object.values(bill).some((val) =>
//           (val || "").toString().toLowerCase().includes(lower),
//         ),
//       );
//     }

//     setFilteredBills(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, newData, selectedDistricts, selectedTaluka, selectedType]);

//   const handleCheckboxChange = (district) => {
//     setSelectedDistricts((prev) =>
//       prev.includes(district)
//         ? prev.filter((d) => d !== district)
//         : [...prev, district],
//     );
//   };
//   const allDistricts = [
//     ...new Set(AllDistrict?.map((d) => d.District_Marathi)),
//   ];
//   const isAllSelected = selectedDistricts.length === allDistricts.length;

//   const toggleAllDistricts = () => {
//     setSelectedDistricts(isAllSelected ? [] : allDistricts);
//   };

//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const [progressImages, setProgressImages] = useState([]);
//   const [progressData, setProgressData] = useState([]);
//  const openProgressModal = (images, location) => {
//     try {
//       const parsedImages = JSON.parse(images || "[]");
//       const parsedLocations = JSON.parse(location || "[]");

//       let imageArray = [];

//       parsedImages.forEach((img) => {
//         try {
//           const nested = JSON.parse(img);

//           if (Array.isArray(nested)) {
//             imageArray.push(...nested);
//           } else {
//             imageArray.push(img);
//           }
//         } catch {
//           imageArray.push(img);
//         }
//       });

//       const combinedData = imageArray.map((image, index) => {
//         let locationObj = {};

//         try {
//           locationObj = JSON.parse(parsedLocations[index] || "{}");
//         } catch (err) {
//           console.log(err);
//         }

//         return {
//           image,
//           location: locationObj,
//         };
//       });

//       console.log("combinedData", combinedData);

//       setProgressData(combinedData);
//       setShowProgressModal(true);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <>
//       <div style={{ backgroundColor: "#dfdcf6" }}>
//         {showspecific == 0 && (
//           <div
//             className="col-12 py-5"
//             style={{ overflow: "auto", height: "90vh" }}
//           >
//             <div className="col-12">
//               <div style={{ width: "96%" }} className="m-auto">
//                 <div
//                   style={{ display: "flex", justifyContent: "space-evenly" }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "space-between",
//                       width: "17rem",
//                       height: "6rem",
//                       borderRadius: "10px",
//                       background: "white",
//                       padding: "10px",
//                       boxShadow: "0px 0px 3px",
//                       position: "relative",
//                     }}
//                   >
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       <img
//                         src={TotalProjectCost}
//                         style={{
//                           width: "40px",
//                           height: "40px",
//                           marginRight: "10px",
//                         }}
//                       />
//                       <div>
//                         <h6
//                           style={{
//                             color: "darkgray",
//                             margin: 0,
//                             cursor: "pointer",
//                           }}
//                         >
//                           {t("Liability")}
//                         </h6>
//                         <h5 style={{ margin: 0 }}>
//                           {Number(liabilityData || 0).toLocaleString("en-IN")}
//                         </h5>
//                       </div>
//                     </div>

//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         color: "blue",
//                         alignSelf: "flex-start",
//                       }}
//                     >
//                       <p
//                         style={{ margin: 0, cursor: "pointer" }}
//                         onClick={() => setSpecific(1)}
//                       >
//                         {t("See Details")}
//                       </p>
//                     </div>
//                     <span
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         fontSize: "18px",
//                         color: "blue",
//                       }}
//                       onClick={() => setSpecific(1)}
//                     >
//                       &rarr;
//                     </span>
//                   </div>

//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       width: "17rem",
//                       height: "6rem",
//                       borderRadius: "10px",
//                       background: "white",
//                       backdropFilter: "blur(52px)",
//                       border: "1px solid #eee",
//                       padding: "10px",
//                       boxShadow: "0px 0px 3px",
//                     }}
//                   >
//                     <img
//                       src={AvailableBalance}
//                       style={{
//                         width: "40px",
//                         height: "40px",
//                         marginRight: "10px",
//                       }}
//                     />
//                     <div>
//                       <h6 style={{ color: "darkgray", margin: 0 }}>
//                         {t("Available Balance in Bank")}
//                       </h6>
//                       <h5 style={{ margin: 0 }}>
//                         {Number(TotalPaidCount).toLocaleString("en-IN") || 0}
//                       </h5>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           color: "blue",
//                           alignSelf: "flex-start",
//                         }}
//                       >
//                         <p
//                           style={{ margin: 0, cursor: "pointer" }}
//                           onClick={() => setSpecific(2)}
//                         >
//                           {t("See Details")}
//                         </p>
//                       </div>
//                       <span
//                         style={{
//                           position: "absolute",
//                           right: "10px",
//                           top: "50%",
//                           transform: "translateY(-50%)",
//                           fontSize: "18px",
//                           color: "blue",
//                         }}
//                       >
//                         &rarr;
//                       </span>
//                     </div>
//                   </div>

//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       width: "17rem",
//                       height: "6rem",
//                       borderRadius: "10px",
//                       background: "white",
//                       backdropFilter: "blur(52px)",
//                       border: "1px solid #eee",
//                       padding: "10px",
//                       boxShadow: "0px 0px 3px",
//                     }}
//                   >
//                     <img
//                       src={ExcessShortfall64}
//                       style={{
//                         width: "40px",
//                         height: "40px",
//                         marginRight: "10px",
//                       }}
//                     />
//                     <div>
//                       <h6 style={{ color: "darkgray", margin: 0 }}>
//                         {t("Excess/Shortfall")}
//                       </h6>
//                       {/* <h5 style={{ margin: 0 }}>
//                         ₹{" "}
//                         {(
//                           BankBalance.AvailableBalanceinBank - liabilityData
//                         ).toLocaleString("en-IN")}
//                       </h5> */}
//                       <h5 style={{ margin: 0 }}>₹ {(0).toLocaleString("en-IN")}</h5>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 pb-2 pt-4">
//               {/* <div className='m-auto' style={{ backgroundColor: "#EFF3F8", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}> */}

//               <div
//                 className="col-12 pb-2"
//                 style={{ padding: "40px 40px", borderRadius: "20px" }}
//               >
//                 <div
//                   className="m-auto mb-3"
//                   style={{
//                     backgroundColor: "white",
//                     padding: "40px 40px",
//                     boxShadow: "0px 0px 5px 1px #E4E8EC",
//                     borderRadius: "20px",
//                     width: "100%",
//                     maxWidth: "100%",
//                     overflowX: "hidden",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       marginBottom: "20px",
//                     }}
//                   >
//                     <h5 className="my-auto fw-bold">
//                       <img
//                         src="/Details-64.png"
//                         alt="Details"
//                         style={{ width: "24px", height: "24px" }}
//                         className="my-auto me-1"
//                       />
//                       <span className="my-auto ">{t("Project Details")}</span>
//                     </h5>

//                     {/* <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                       <select
//                         value={selectedDistrict}
//                         placeholder='Choose District'
//                         onChange={(e) => setselectedDistrict(e.target.value)}
//                         style={{
//                           width: "100%",
//                           padding: "8px 12px 8px 32px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           fontSize: "14px",
//                           color: "#333",
//                           boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                           outline: "none"
//                         }}>
//                         <option value="" disabled>Select District</option>
//                         {
//                           AllDistrict &&
//                           [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
//                             return (
//                               <option key={index} value={district}>{district}</option>
//                             )
//                           })
//                         }
//                       </select>
//                     </div> */}

//                     <div style={{ position: "relative", width: "260px", marginRight: "10px" }}>
//                     <select
//   value={selectedType}
//   onChange={(e) => setselectedType(e.target.value)}
//   style={{
//     width: "100%",
//     padding: "8px 12px", // remove extra left padding
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     backgroundColor: "#f1f6fc",
//     fontSize: "14px",
//     color: "#333",
//     appearance: "none",
//     WebkitAppearance: "none",
//     MozAppearance: "none",
//   }}
// >
//   <option value="" >Select Work Order Type</option>
//   <option value="Existing Work Order">Existing Work Order</option>
//   <option value="New Work Order">New Work Order</option>
// </select>
//                     </div>
//                     <div
//                       style={{
//                         position: "relative",
//                         width: "250px",
//                         marginRight: "10px",
//                       }}
//                     >
//                       {/* Trigger */}
//                       <div
//                         onClick={() => setOpen(true)}
//                         style={{
//                           padding: "8px 12px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           cursor: "pointer",
//                           fontSize: "14px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         {selectedDistricts.length > 0
//                           ? selectedDistricts.join(", ")
//                           : t("Select District")}
//                       </div>

//                       {/* Dropdown */}
//                       {open && (
//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "100%",
//                             left: 0,
//                             width: "100%",
//                             background: "#fff",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
//                             zIndex: 10,
//                           }}
//                         >
//                           <label
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               padding: "6px 8px",
//                               borderBottom: "1px solid #eee",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                             }}
//                           >
//                             <input
//                               type="checkbox"
//                               checked={isAllSelected}
//                               onChange={toggleAllDistricts}
//                               style={{ marginRight: "6px" }}
//                             />
//                             {t("All Districts")}
//                           </label>
//                           {/* List */}
//                           <div
//                             style={{ maxHeight: "180px", overflowY: "auto" }}
//                           >
//                             {[
//                               ...new Set(
//                                 AllDistrict.map((d) => d.District_Marathi),
//                               ),
//                             ].map((district, index) => (
//                               <label
//                                 key={index}
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   padding: "8px",
//                                   cursor: "pointer",
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   checked={selectedDistricts.includes(district)}
//                                   onChange={() =>
//                                     handleCheckboxChange(district)
//                                   }
//                                   style={{ marginRight: "8px" }}
//                                 />
//                                 {district}
//                               </label>
//                             ))}
//                           </div>

//                           {/* OK button */}
//                           <div
//                             style={{
//                               borderTop: "1px solid #eee",
//                               padding: "8px",
//                               textAlign: "right",
//                             }}
//                           >
//                             <button
//                               onClick={() => setOpen(false)}
//                               style={{
//                                 padding: "6px 14px",
//                                 borderRadius: "6px",
//                                 border: "none",
//                                 background: "#0d6efd",
//                                 color: "#fff",
//                                 cursor: "pointer",
//                                 fontSize: "13px",
//                               }}
//                             >
//                               OK
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     <div
//                       style={{
//                         position: "relative",
//                         width: "240px",
//                         marginRight: "10px",
//                       }}
//                     >
//                       <select
//                         placeholder="Choose Taluka"
//                         value={selectedTaluka}
//                         onChange={(e) => setselectedTaluka(e.target.value)}
//                         style={{
//                           width: "100%",
//                           padding: "8px 12px 8px 32px", // left padding makes space for icon
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           fontSize: "14px",
//                           color: "#333",
//                           boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                           outline: "none",
//                         }}
//                       >
//                         <option value="">{t("Select Taluka")}</option>
//                         {TalukasofDistrict.length > 0 &&
//                           TalukasofDistrict.map((val, index) => {
//                             return (
//                               <option key={index} value={val.ULBNameMarathi}>
//                                 {val.ULBNameMarathi}
//                               </option>
//                             );
//                           })}
//                       </select>
//                     </div>

//                     <div
//                       style={{
//                         position: "relative",
//                         width: "250px",
//                         marginRight: "10px",
//                       }}
//                     >
//                       <img
//                         src="/Search32.png"
//                         alt="Search Icon"
//                         style={{
//                           position: "absolute",
//                           top: "50%",
//                           left: "10px",
//                           transform: "translateY(-50%)",
//                           width: "16px",
//                           height: "16px",
//                           opacity: 0.6,
//                         }}
//                       />
//                       <input
//                         type="text"
//                         placeholder={t("Search Here")}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         value={searchTerm}
//                         style={{
//                           width: "100%",
//                           padding: "8px 12px 8px 32px", // left padding makes space for icon
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           fontSize: "14px",
//                           color: "#333",
//                           boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                           outline: "none",
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div
//                     className="col-12 tableDesign"
//                     style={{ background: "#2C78DB" }}
//                   >
//                     <table
//                       className="m-0 p-0"
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             color: "white",
//                             border: "none",
//                             height: "3rem",
//                             fontSize: "12px",
//                           }}
//                         >
//                           <th style={{ width: "6%" }}>{t("Sr.No")}</th>
//                           <th style={{ width: "20%" }}>{t("Work Name")}</th>
//                           <th style={{ width: "10%" }}>{t("District")}</th>
//                           <th style={{ width: "10%" }}>{t("Taluka")}</th>
//                           <th style={{ width: "14%" }}>{t("Work order No")}</th>
//                           <th style={{ width: "14%" }}>{t("Work order Date")}</th>
//                           <th style={{ width: "14%" }}>{t("Physical Progress")}</th>
//                           <th style={{ width: "12%" }}>{t("Approved Work Order Amount")}</th>
//                           {/* <th style={{ width: "14%" }}>{t("Work Remaining Amount")}</th> */}
//                           <th style={{ width: "14%" }}>{t("Bill Amount")}</th>
//                           <th style={{ width: "14%" }}>{t("Balance")}</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentBills?.length < 1 ? (
//                           <tr>
//                             <td
//                               colSpan="10"
//                               style={{
//                                 textAlign: "center",
//                                 padding: "20px",
//                                 backgroundColor: "#f9f9f9",
//                                 fontSize: "12px",
//                               }}
//                             >
//                               {t("No Data Found")}
//                             </td>
//                           </tr>
//                         ) : (
//                           currentBills?.map((val, index) => {
//                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

//                             return (
//                               <tr
//                                 key={index}
//                                 style={{
//                                   backgroundColor: bgColor,
//                                   fontSize: "12px",
//                                   fontWeight: "500",
//                                 }}
//                               >
//                                 <td style={{ padding: "8px" }}>
//                                   {indexOfFirstBill + index + 1}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>{val.WorkName}</td>
//                                 <td style={{ padding: "8px" }}>{val.talulka}</td>
//                                 <td style={{ padding: "8px" }}>{val.ulb}</td>
//                                 <td style={{ padding: "8px" }}>
//                                   {(val.WorkOrderNo || 0)}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//   {(val.WorkOrderDate &&
//                                 new Date(val.WorkOrderDate).toLocaleString()) ||
//                                 "-"}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                       <span
//                                 style={{
//                                   color: "blue",
//                                   textDecoration: "underline",
//                                   cursor: "pointer",
//                                 }}
//                                 onClick={() =>
//                                   openProgressModal(
//                                     val.Upload,
//                                     val.Location,
//                                   )
//                                 }
//                               >
//                                   {(val.physicalValue||0 ).toLocaleString("en-IN")}</span>
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(val.ApprovedWorkAmount || 0).toLocaleString("en-IN")}
//                                 </td>
//                                 {/* <td style={{ padding: "8px" }}>
//                                   {Number(val.RemainingAmount || 0).toLocaleString("en-IN")}
//                                 </td> */}
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(val.BillPaidAmount || 0).toLocaleString("en-IN")}
//                                 </td>
//                                  <td style={{ padding: "8px" }}>
//                                   {Number(val.RemainingAmount || 0)- Number(val.BillPaidAmount || 0)}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         )}

//                         {filteredBills?.length > 0 &&
//                           (() => {
//                           const totals = filteredBills.reduce(
//   (acc, val) => {
//     acc.totalAvailable += Number(val.ApprovedWorkAmount || 0);
//     acc.totalBillPaid += Number(val.BillPaidAmount || 0);
//     acc.totalBalance = acc.totalAvailable - acc.totalBillPaid;

//     return acc;
//   },
//   {
//     totalAvailable: 0,
//     totalBillPaid: 0,
//     totalBalance: 0,
//   }
// );

//                             return (
//                               <tr
//                                 style={{
//                                   backgroundColor: "#d9e1e9",
//                                   fontSize: "12px",
//                                   fontWeight: "700",
//                                 }}
//                               >
//                                 <td colSpan="7" style={{ padding: "8px" }}>
//                                   {t("Total")}
//                                 </td>

//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalAvailable.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalBillPaid.toLocaleString()}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalBalance.toLocaleString("en-IN")}
//                                 </td>

//                               </tr>
//                             );
//                           })()}
//                       </tbody>
//                     </table>

//                     {/* --> old code table */}
//                     {/* <table
//                       className="m-0 p-0"
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             color: "white",
//                             border: "none",
//                             height: "3rem",
//                             fontSize: "12px",
//                           }}
//                         >
//                           <th style={{ width: "6%" }}>{t("Sr.No")}</th>
//                           <th style={{ width: "20%" }}>{t("Proposal Name")}</th>
//                           <th style={{ width: "10%" }}>{t("District")}</th>
//                           <th style={{ width: "10%" }}>{t("Taluka")}</th>
//                           <th style={{ width: "14%" }}>
//                             {t("Approve Proposal Cost")}
//                           </th>
//                           <th style={{ width: "14%" }}>
//                             {t("Release Amount Till Date")}
//                           </th>
//                           <th style={{ width: "14%" }}>
//                             {t("Demand Request Amount")}
//                           </th>
//                           <th style={{ width: "12%" }}>
//                             {t("Limit Allocation")}
//                           </th>
//                           <th style={{ width: "14%" }}>
//                             {t("Demand Received Amount")}
//                           </th>
//                           <th style={{ width: "14%" }}>
//                             {t("Available to Release")}
//                           </th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentBills?.length < 1 ? (
//                           <tr>
//                             <td
//                               colSpan="10"
//                               style={{
//                                 textAlign: "center",
//                                 padding: "20px",
//                                 backgroundColor: "#f9f9f9",
//                                 fontSize: "12px",
//                               }}
//                             >
//                               {t("No Data Found")}
//                             </td>
//                           </tr>
//                         ) : (
//                           currentBills.map((val, index) => {
//                             const bgColor =
//                               index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

//                             return (
//                               <tr
//                                 key={index}
//                                 style={{
//                                   backgroundColor: bgColor,
//                                   fontSize: "12px",
//                                   fontWeight: "500",
//                                 }}
//                               >
//                                 <td style={{ padding: "8px" }}>
//                                   {indexOfFirstBill + index + 1}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {val.ProposalID}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {val.District}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>{val.Taluka}</td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(val.ProposalCost || 0).toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(
//                                     val.ReleaseAmountTillDate || 0,
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(val.DemandAmount || 0).toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(
//                                     val.OriginalLimitAllocatedAmount || 0,
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(val.BillAmount || 0).toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {Number(
//                                     val.LimitAllottedAmount || 0,
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         )}

//                         {filteredBills?.length > 0 &&
//                           (() => {
//                             const totals = filteredBills.reduce(
//                               (acc, val) => {
//                                 acc.totalCost += Number(val.ProposalCost || 0);
//                                 acc.totalReleased += Number(
//                                   val.ReleaseAmountTillDate || 0,
//                                 );
//                                 acc.totalDemandRequest += Number(
//                                   val.DemandAmount || 0,
//                                 );
//                                 acc.totalLimit += Number(
//                                   val.OriginalLimitAllocatedAmount || 0,
//                                 );
//                                 acc.totalDemand += Number(val.BillAmount || 0);
//                                 acc.totalAvailable += Number(
//                                   val.LimitAllottedAmount || 0,
//                                 );
//                                 return acc;
//                               },
//                               {
//                                 totalCost: 0,
//                                 totalReleased: 0,
//                                 totalDemandRequest: 0,
//                                 totalLimit: 0,
//                                 totalDemand: 0,
//                                 totalAvailable: 0,
//                               },
//                             );

//                             return (
//                               <tr
//                                 style={{
//                                   backgroundColor: "#d9e1e9",
//                                   fontSize: "12px",
//                                   fontWeight: "700",
//                                 }}
//                               >
//                                 <td colSpan="4" style={{ padding: "8px" }}>
//                                   {t("Total")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalCost.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalReleased.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalDemandRequest.toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalLimit.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalDemand.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalAvailable.toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                               </tr>
//                             );
//                           })()}
//                       </tbody>
//                     </table> */}
//                   </div>

//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       height: "4rem",
//                       alignItems: "center",
//                     }}
//                     className="mt-3"
//                   >
//                     <div>
//                       <p className="text-gray-600" style={{ fontSize: "14px" }}>
//                         {t("Showing")}{" "}
//                         {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
//                         {t("to ")}
//                         {Math.min(indexofLastBill, filteredBills.length)}{" "}
//                         {t("of")} {filteredBills.length} {t("entries")}
//                       </p>
//                     </div>
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* </div> */}
//             </div>
//           </div>
//         )}

//         {showspecific == 1 && (
//           <div
//             className="col-12"
//             style={{
//               backgroundColor: "#EFF3F8",
//               height: "90vh",
//               overflowX: "hidden",
//               overflowY: "scroll",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12">
//                 <div className="col-12 text-start mb-4 mt-4">
//                   <button
//                     className="btn btn-danger px-3 rounded-4"
//                     onClick={() => setSpecific(0)}
//                   >
//                     {" "}
//                     <i class="fa fa-arrow-left" aria-hidden="true" />
//                     {t(" Back")}
//                   </button>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                       maxWidth: "100%",
//                       overflowX: "hidden",
//                     }}
//                   >
//                     <div className="col-12 tableDesign">
//                       <table
//                         className="m-0 p-0"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead
//                           style={{ background: "#2C78DB", overflowX: "hidden" }}
//                         >
//                           <tr
//                             style={{
//                               width: "100%",
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "12px",
//                               fontWeight: "500",
//                             }}
//                           >
//                             <th style={{ width: "4%" }}>{t("Sr.No")}</th>
//                             <th style={{ width: "10%" }}>
//                               {t("Project Name")}
//                             </th>
//                             <th style={{ width: "10%" }}>{t("Demand ID")}</th>
//                             <th style={{ width: "10%" }}>{t("Bill Amount")}</th>
//                             {/* <th style={{ width: "10%" }}>Type Of Amount</th> */}
//                             <th style={{ width: "10%" }}>
//                               {t("Payable Amount")}
//                             </th>
//                             <th style={{ width: "10%" }}>
//                               {t("Deduction Amount")}
//                             </th>
//                             <th style={{ width: "10%" }}>{t("Status")}</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentdemands &&
//                             [
//                               ...new Map(
//                                 currentdemands
//                                   .filter((val) => val.DemandGenerationID)
//                                   .map((item) => [
//                                     item.DemandGenerationID,
//                                     item,
//                                   ]),
//                               ).values(),
//                             ].map((val, index) => {
//                               const bgColor =
//                                 index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                               return (
//                                 <tr
//                                   key={index}
//                                   style={{
//                                     backgroundColor: bgColor,
//                                     fontSize: "12px",
//                                     fontWeight: "500",
//                                   }}
//                                 >
//                                   <td style={{ padding: "4px 4px" }}>
//                                     {indexOfFirstBill + index + 1}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.ProjectName}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.DemandGenerationID}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(val.BillAmount).toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   {/* <td style={{ padding: '8px' }}>{val.TypeOfAmount}</td> */}

//                                   <td style={{ padding: "8px" }}>
//                                     {Number(
//                                       val.NetPayableAmount,
//                                     ).toLocaleString("en-IN")}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(val.DeductionAmount).toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.Account_Approval == "true" &&
//                                     val.Admin_Approval == "true" &&
//                                     val.General_Manager_Approval == "true"
//                                       ? "Approve"
//                                       : "Pending"}
//                                   </td>
//                                 </tr>
//                               );
//                             })}

//                           {currentdemands &&
//                             currentdemands.length > 0 &&
//                             (() => {
//                               const filteredUnique = [
//                                 ...new Map(
//                                   currentdemands
//                                     .filter((val) => val.DemandGenerationID)
//                                     .map((item) => [
//                                       item.DemandGenerationID,
//                                       item,
//                                     ]),
//                                 ).values(),
//                               ];

//                               const totals = filtereddemand.reduce(
//                                 (acc, val) => {
//                                   acc.totalBillamount += Number(
//                                     val.BillAmount || 0,
//                                   );
//                                   acc.totalNetPayable += Number(
//                                     val.NetPayableAmount || 0,
//                                   );
//                                   acc.totalDeduction += Number(
//                                     val.DeductionAmount || 0,
//                                   );
//                                   return acc;
//                                 },
//                                 {
//                                   totalBillamount: 0,
//                                   totalNetPayable: 0,
//                                   totalDeduction: 0,
//                                 },
//                               );

//                               return (
//                                 <tr
//                                   style={{
//                                     background: "#cbd1d8",
//                                     fontWeight: "bold",
//                                   }}
//                                 >
//                                   <td colSpan={3} style={{ padding: "8px" }}>
//                                     {t("Total")}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {totals.totalBillamount.toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {totals.totalNetPayable.toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {totals.totalDeduction.toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}></td>
//                                 </tr>
//                               );
//                             })()}
//                         </tbody>
//                       </table>
//                     </div>

//                     <div
//                       className="col-12"
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         margin: "25px 0",
//                       }}
//                     >
//                       <div>
//                         <p
//                           className="text-gray-600"
//                           style={{ fontSize: "14px", margin: 0 }}
//                         >
//                           {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
//                           {Math.min(indexofLastBill, filtereddemand.length)}{" "}
//                           {t("of")} {filtereddemand.length} {t("entries")}
//                         </p>
//                       </div>

//                       <div style={{ display: 'flex', alignItems: 'center' }}>
//                                             <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages1}
//                         onPageChange={setCurrentPage}
//                       />
//                                           </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {showspecific == 2 && (
//           <div
//             className="col-12"
//             style={{
//               backgroundColor: "#EFF3F8",
//               height: "90vh",
//               overflowX: "hidden",
//               overflowY: "scroll",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12">
//                 <div className="col-12 text-start mb-4 mt-4">
//                   <button
//                     className="btn btn-danger px-3 rounded-4"
//                     onClick={() => setSpecific(0)}
//                   >
//                     {" "}
//                     <i class="fa fa-arrow-left" aria-hidden="true" /> Back
//                   </button>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                       maxWidth: "100%",
//                       overflowX: "hidden",
//                     }}
//                   >
//                     <div className="col-12 tableDesign">
//                       <table
//                         className="m-0 p-0"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead
//                           style={{ background: "#2C78DB", overflowX: "hidden" }}
//                         >
//                           <tr
//                             style={{
//                               width: "100%",
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "12px",
//                               fontWeight: "500",
//                             }}
//                           >
//                             <th style={{ width: "4%" }}>{t("Sr.No")}</th>
//                             <th style={{ width: "10%" }}>{t("Release ID")}</th>
//                             <th style={{ width: "10%" }}>{t("Financial")}</th>
//                             <th style={{ width: "10%" }}>{t("District")}</th>
//                             <th style={{ width: "10%" }}>{t("Taluka")}</th>
//                             {/* <th style={{ width: "10%" }}>GR ID</th> */}
//                             <th style={{ width: "20%" }}>
//                               {t("Proposal Name")}
//                             </th>
//                             <th style={{ width: "10%" }}>
//                               {t("Project Cost")}
//                             </th>
//                             <th style={{ width: "10%" }}>
//                               {t("Original Limit")}
//                             </th>
//                             <th style={{ width: "10%" }}>
//                               {t("Release Amount")}
//                             </th>
//                             <th style={{ width: "10%" }}>
//                               {t("Available Limit")}
//                             </th>
//                           </tr>
//                         </thead>
//                         {currentbalance &&
//                           currentbalance.map((val, index) => {
//                             let TotalReleasedAmount = Number(
//                               val.OriginalLimitAllocatedAmount -
//                                 val.LimitAllottedAmount,
//                             );
//                             const bgColor =
//                               index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                             return (
//                               <tbody>
//                                 <tr
//                                   key={index}
//                                   style={{
//                                     backgroundColor: bgColor,
//                                     fontSize: "12px",
//                                     fontWeight: "500",
//                                   }}
//                                 >
//                                   <td style={{ padding: "4px 4px" }}>
//                                     {indexOfFirstBill + index + 1}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.ReleaseID}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.FinancialYear}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.District}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {val.Taluka}
//                                   </td>
//                                   {/* <td style={{ padding: '8px' }}>{val.GRID}</td> */}
//                                   <td style={{ padding: "8px" }}>
//                                     {val.ProposalID}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(val.ProposalCost).toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(
//                                       val.OriginalLimitAllocatedAmount,
//                                     ).toLocaleString("en-IN")}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(TotalReleasedAmount).toLocaleString(
//                                       "en-IN",
//                                     )}
//                                   </td>
//                                   <td style={{ padding: "8px" }}>
//                                     {Number(
//                                       val.LimitAllottedAmount,
//                                     ).toLocaleString("en-IN")}{" "}
//                                   </td>
//                                 </tr>
//                               </tbody>
//                             );
//                           })}

//                         {availabeBalancinBank &&
//                           availabeBalancinBank.length > 0 &&
//                           (() => {
//                             const totals = availabeBalancinBank.reduce(
//                               (acc, val) => {
//                                 let TotalReleasedAmount = Number(
//                                   val.OriginalLimitAllocatedAmount -
//                                     val.LimitAllottedAmount,
//                                 );
//                                 acc.totalCost += Number(val.ProposalCost || 0);
//                                 acc.totalOriginReleased += Number(
//                                   val.OriginalLimitAllocatedAmount || 0,
//                                 );
//                                 acc.totalReleased += Number(
//                                   TotalReleasedAmount || 0,
//                                 );
//                                 acc.totalLimit += Number(
//                                   val.LimitAllottedAmount || 0,
//                                 );

//                                 return acc;
//                               },
//                               {
//                                 totalCost: 0,
//                                 totalOriginReleased: 0,
//                                 totalReleased: 0,
//                                 totalLimit: 0,
//                               },
//                             );

//                             return (
//                               <tr
//                                 style={{
//                                   background: "#e2e8f0",
//                                   fontWeight: "bold",
//                                 }}
//                               >
//                                 <td
//                                   colSpan={6}
//                                   style={{
//                                     padding: "8px",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   {t("Total")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalCost.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalOriginReleased.toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalReleased.toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {totals.totalLimit.toLocaleString("en-IN")}
//                                 </td>
//                               </tr>
//                             );
//                           })()}
//                       </table>
//                       {/* <div className='col-12 text-white' style={{ backgroundColor: "#0094DE" }}>
//                     <p className='col-11 text-end py-2 fw-bold'>11,00,00,000.00</p>
//                   </div> */}
//                     </div>

//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p
//                           className="text-gray-600"
//                           style={{ fontSize: "14px" }}
//                         >
//                           {t("Showing")}{" "}
//                           {availabeBalancinBank.length > 0
//                             ? indexOfFirstBill + 1
//                             : 0}{" "}
//                           {t("to ")}
//                           {Math.min(
//                             indexofLastBill,
//                             availabeBalancinBank.length,
//                           )}{" "}
//                           {t("of")} {availabeBalancinBank.length} {t("entries")}
//                         </p>
//                       </div>
//                       <div style={{ display: 'flex', alignItems: 'center' }}>
//                                             <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages2}
//                         onPageChange={setCurrentPage}
//                       />
//                                           </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {showProgressModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ background: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Physical Progress Images</h5>

//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowProgressModal(false)}
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="row">
//                   {progressData?.length > 0 ? (
//                     progressData.map((item, index) => (
//                       <div className="col-md-4 mb-3" key={index}>
//                         <div
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: "10px",
//                             padding: "10px",
//                             background: "#fff",
//                           }}
//                         >
//                           <img
//                             src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
//                             alt="progress"
//                             className="img-fluid rounded"
//                             style={{
//                               width: "100%",
//                               maxHeight: "250px",
//                               objectFit: "contain",
//                             }}
//                           />

//                           <div
//                             style={{
//                               marginTop: "10px",
//                               fontSize: "14px",
//                               lineHeight: "1.7",
//                             }}
//                           >
//                             <div>
//                               📍 <strong>Latitude:</strong>{" "}
//                               {item.location?.latitude || "-"}
//                             </div>

//                             <div>
//                               📍 <strong>Longitude:</strong>{" "}
//                               {item.location?.longitude || "-"}
//                             </div>

//                             <div>
//                               📅 <strong>Date:</strong>{" "}
//                               {item.location?.date || "-"}
//                             </div>

//                             <div>
//                               🕒 <strong>Time:</strong>{" "}
//                               {item.location?.time || "-"}
//                             </div>

//                             <div>
//                               ⛰️ <strong>Elevation:</strong>{" "}
//                               {item.location?.elevation || "-"} m
//                             </div>

//                             <div>
//                               🎯 <strong>Accuracy:</strong>{" "}
//                               {item.location?.accuracy || "-"} m
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <p>No Images Found</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       </div>
//     </>
//   );
// };

// export default ProjectDashboard;
